import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
const FileUploadProductB = ({ onUploadSuccess }) => {
  const [file, setFile] = useState(null);
  const [file2, setFile2] = useState(null);
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState(null);
  const [statusCC, setStatusCC] = useState(null);
  const [statusTF, setStatusTF] = useState(null);
  const [errorCodeCC, setErrorCodeCC] = useState(null);
  const [riverchainID, setRiverchainID] = useState(null);
  const [borrowerNameEng, setBorroerNameEng] = useState(null);
  const [borrowerNameChinese, setBorrowerNameChinese] = useState(null);
  const [finalUpload, setFinalUpload] = useState(false);
  const [registeredAddress, setRegisteredAddress] = useState(null);
  const [placeofincorporation, setPlaceofincorporation] = useState(null);
  const [contactname, setContactname] = useState(null);
  const [contactnameFirstAndLast, setContactnameFirstAndLast] = useState(null);
  const [contactemailaddress, setContactemailaddress] = useState(null);
  const [contactphonenumber, setContactphonenumber] = useState(null);
  const [businessRegistrationNumber, setBusinessRegistrationNumber] =
    useState(null);
  const [bankName, setBankName] = useState(null);
  const [bankAccNo, setBankAccNo] = useState(null);
  const [benifiserName, setBenifiserName] = useState(null);
  const [bankCode, setBankCode] = useState(null);
  const [swift, setSwift] = useState(null);

  //   TF
  const [errorCodeTF, SetErrorCodeTF] = useState(null);
  const [lenderNo, setLenderNo] = useState(null);
  const [productNo, setProductNo] = useState(null);
  const [facilityLimit, setFacilityLimit] = useState(null);
  const [drawDownAvailability, SetDrawDownAvailability] = useState(null);
  const [interestRate, setInterestRate] = useState(null);
  const [maxTerm, setMaxTerm] = useState(null);
  const [repaymentOne, setRepaymentOne] = useState(null);
  const [invoiceAmount, setInvoiceAmount] = useState(null);
  const [invoiceAmount2, setInvoiceAmount2] = useState(null);
  const [invoiceAmountFinal, setInvoiceAmountFinal] = useState(null);
  const [invoiceFinancing, setInvoiceFinancing] = useState(null);
  const [projectDetails, setProjectDetails] = useState(null);
  const [contractStartDate, setContractStartDate] = useState(null);
  const [invoiceNo, setInvoiceNo] = useState(null);
  const [invoiceNo2, setInvoiceNo2] = useState(null);
  const [invoiceNo3, setInvoiceNo3] = useState(null);
  const [invoiceDate, setInvoiceDate] = useState(null);
  const [invoiceDate2, setInvoiceDate2] = useState(null);
  const [invoiceDate3, setInvoiceDate3] = useState(null);
  const [borrowerContractor, setBorrowerContractor] = useState(null);
  const [adminFee, setAdminFee] = useState(null);
  const [subContractorNo, setSubContractorNo] = useState(null);
  const [employer, setEmployer] = useState(null);
  const [contractType, setContractType] = useState(null);
  const [contractType2, setContractType2] = useState(null);
  const [contractType3, setContractType3] = useState(null);
  const [subContractNo2, setSubContractNo2] = useState(null);
  const [subContractNo3, setSubContractNo3] = useState(null);
  const [subContractprojectDetails, setSubContractprojectDetails] =
    useState(null);
  const [subContractprojectDetails3, setSubContractprojectDetails3] =
    useState(null);
  const [subContractStartDate, setSubContractStartDate] = useState(null);
  const [subContractStartDate3, setSubContractStartDate3] = useState(null);
  const [emp2, setEmp2] = useState(null);
  const [emp3, setEmp3] = useState(null);
  const [borowwersContractor2, setBorowwersContractor2] = useState(null);
  const [borowwersContractor3, setBorowwersContractor3] = useState(null);
  const [paymentCertvalue, setPaymentCertvalue] = useState(null);
  const [certiCumValue, setCertiCumValue] = useState();
  const [subContractInvoiceAmount2, setSubContractInvoiceAmount2] =
    useState(null);

  const [subContractInvoiceAmount3, setSubContractInvoiceAmount3] =
    useState(null);

  // new company card
  const [companyNameInEnglish, setCompanyNameInEnglish] = useState(null);
  const [companyNameInChinese, setCompanyNameInChinese] = useState(null);

  const [product_type, setProduct_type] = useState(null);
  const [TransactionID, setTransactionID] = useState(null);
  const [Lender_Purchaser, setLender_Purchaser] = useState(null);
  const [loan_type_2_1, setLoan_type_2_1] = useState(null);
  const [facilityPrepaymentLimit, setFacilityPrepaymentLimit] = useState(null);
  const [interestRate8_7, setInterestRate8_7] = useState(null);
  const [Repayment_2_1, setRepayment_2_1] = useState(null);
  const [invoiceFinancing8_7, setInvoiceFinancing8_7] = useState(null);
  const [mainContractor, setMainContractor] = useState(null);
  const [adminFee8_7, setAdminFee_8_7] = useState(null);
  const [subcontractProjectDetails1, setSubcontractProjectDetails1] =
    useState(null);
  const [contractStartDate1, setContractStartDate1] = useState(null);
  const [receivableNo_01, setReceivableNo_01] = useState(null);
  const [receivableNo_02, setReceivableNo_02] = useState(null);
  const [applicationDate_01, setApplicationDate_01] = useState(null);
  const [applicationDate_02, setApplicationDate_02] = useState(null);
  const [applicationDate_03, setApplicationDate_03] = useState(null);
  const [applicationValue_01, setApplicationValue_01] = useState(null);
  const [employer_Contract1, setEmployer_Contract1] = useState(null);
  const [contractType_Contract1_no, setContractType_Contract1_no] =
    useState(null);
  const [receivableNo_03, setReceivableNo_03] = useState(null);
  const [applicationValue_02, setApplicationValue_02] = useState(null);
  const [applicationValue_03, setApplicationValue_03] = useState(null);
  const [certificateNo_01, setCertificateNo_01] = useState(null);
  const [certificateDate_01, setCertificateDate_01] = useState(null);
  const [certificateIssueby_01, setCertificateIssueby_01] = useState(null);
  const [certificateValue_01, setCertificateValue_01] = useState(null);
  const [certificateValue_02, setCertificateValue_02] = useState(null);
  const [certificateValue_03, setCertificateValue_03] = useState(null);
  const [certifiedtoDate_exclVO1, setCertifiedtoDate_exclVO1] = useState(null);
  const [subContractNo_Contract2, setSubContractNo_Contract2] = useState(null);
  const [contractStartDate_Contract2, setContractStartDate_Contract2] =
    useState(null);
  const [mainContractor_Contract2, setMainContractor_Contract2] =
    useState(null);

  const [
    subcontractDescription_Contract2,
    setSubcontractDescription_Contract2,
  ] = useState(null);

  const [collectionAccount, setCollectionAccount] = useState(null);
  const [defaultInterestRate, setDefaultInterestrate] = useState(null);
  const [tranche1Limit, setTranche1Limit] = useState(null);
  const [tranche2Limit, setTranche2Limit] = useState(null);
  const [tranche3Limit, setTranche3Limit] = useState(null);
  const [subContractNo_Contract3, setSubContractNo_Contract3] = useState(null);
  const [ContractStartDate_Contract3, setContractStartDate_Contract3] =
    useState(null);
  const [
    subcontractDescription_Contract3,
    setSubcontractDescription_Contract3,
  ] = useState(null);

  const [employer_Contract2, setEmployer_Contract2] = useState(null);
  const [employer_Contract3, setEmployer_Contract3] = useState(null);
  const [contractType_Contract3, setContractType_Contract3] = useState(null);
  const [contractForm_Contract1, setContractForm_Contract1] = useState(null);
  const [contractForm_Contract2, setContractForm_Contract2] = useState(null);
  const [contractForm_Contract3, setContractForm_Contract3] = useState(null);
  const [dateofFacilityLetter, setDateofFacilityLetter] = useState(null);
  const [maxTermofPayment_months, setMaxTermofPayment_months] = useState(null);
  const [maxTermofPayment_days, setMaxTermofPayment_days] = useState(null);
  const [facilityAvailabilityPeriod_days, setFacilityAvailabilityPeriod_days] =
    useState(null);
  const [
    facilityAvailabilityPeriod_months,
    setFacilityAvailabilityPeriod_months,
  ] = useState(null);
  const [currency_symbol, setCurrency_symbol] = useState(null);
  const [subContractNo_Contract1, setSubContractNo_Contract1] = useState(null);
  const [contractType_Contract2_no, setContractType_Contract2_no] =
    useState(null);
  const [mainContractor_Contract3, setMainContractor_Contract3] =
    useState(null);

  const [alertMsg, setAlertMsg] = useState("");
  const [alertType, setAlertType] = useState(""); // success, danger, warning, info

  const hasVerifiedRef = useRef(false);

  const fileInputRef = useRef(null);
  const fileInputRef2 = useRef(null);

  const BACKEND_URL = "https://uat.atlas.docauto.riverchain.xyz";
  const API_URL = "https://uat.atlas.docauto.riverchain.xyz/api";

  const resetAll = () => {
    setFile(null);
    setFile2(null);
    setStatus(null);
    setStatusTF(null);

    setFinalUpload(false);
    setProduct_type("");
    setAlertMsg(null);
    setAlertType("");
    setLoading(false);

    // clear file inputs
    if (fileInputRef.current) fileInputRef.current.value = "";
    if (fileInputRef2.current) fileInputRef2.current.value = "";
  };

  function formatNewDate(dateString) {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0"); // Ensure 2 digits
    const monthFull = date.toLocaleString("default", { month: "long" });
    const month = monthFull.slice(0, 3); // Take only the first 3 letters
    const year = date.getFullYear();

    return `${day} ${month} ${year}`;
  }

  const formatDateDDMMMYYY = (input) => {
    if (!input) return "";

    const date = new Date(input);
    if (isNaN(date)) return "";

    const months = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];

    const day = String(date.getDate()).padStart(2, "0");
    const month = months[date.getMonth()];
    const year = date.getFullYear();

    return `${day} ${month} ${year}`;
  };

  const convertRate = (value) => {
    if (value == null || value === "") return "";
    const cleaned = Number(String(value).replace("%", ""));
    return (cleaned * 100).toFixed(2);
  };

  useEffect(() => {
    console.log("STATE UPDATED:", product_type, productNo);
  }, [product_type, productNo]);

  const handleUploadCC = async () => {
    try {
      if (!file) {
        console.error("First file is missing!");
        setStatus("Please select the first file.");
        return false;
      }

      const formData1 = new FormData();
      formData1.append("file", file);

      console.log("Uploading first file...1");
      const response = await fetch(`${BACKEND_URL}/uploadfile/`, {
        method: "POST",
        body: formData1,
        headers: { Accept: "application/json" },
      });

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(`Server error: ${response.status} - ${errorText}`);
      }
      const data = await response.json();
      console.log("First file uploaded successfully:", data);
      setPlaceofincorporation(data.content?.Placeofincorporation ?? "");
      setBorrowerNameChinese(data.content?.CompanyName_Chinese ?? "");
      setCompanyNameInEnglish(data.content?.CompanyName_English ?? "");

      setCompanyNameInChinese(data.content?.CompanyName_Chinese ?? "");
      setRegisteredAddress(data.content?.RegisteredAddress ?? "");
      setContactname(
        data.content?.Contactname != null ? data.content?.Contactname : ""
      );
      const fullName = data.content?.Contactname ?? "";
      const parts = fullName.trim().split(/\s+/);
      const firstName = parts[0] ?? "";
      const lastName = parts.length > 1 ? parts[parts.length - 1] : "";
      setContactnameFirstAndLast(`${firstName} ${lastName}`.trim());

      setContactemailaddress(data.content?.Contactemailaddress ?? "");
      setContactphonenumber(data.content?.Contactphonenumber ?? "");

      setBusinessRegistrationNumber(
        data.content?.BusinessRegistrationNumber ?? ""
      );
      setBankAccNo(data.content?.BankAccountNumber ?? "");
      setBankName(data.content?.BankName != null ? data.content?.BankName : "");
      setBenifiserName(data.content?.BeneficiaryName ?? "");
      setBankCode(data.content?.BankCode ?? "");
      setSwift(data.content?.SWIFT ?? "");
      setErrorCodeCC(data.content?.status);

      return true;
    } catch (error) {
      console.error("Error uploading first file:", error);
      setStatus("Error uploading first file. Check console for details.");
      return false;
    }
  };

  const handleUploadTF = async () => {
    try {
      if (!file2) {
        console.error("Second file is missing!");
        setStatus("Please select the second file.");
        return;
      }
      const formData2 = new FormData();
      formData2.append("file", file2);

      console.log("Uploading second file...");
      const response = await fetch(`${BACKEND_URL}/uploadTFPRODBfile/`, {
        method: "POST",
        body: formData2,
        headers: { Accept: "application/json" },
      });

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(`Server error: ${response.status} - ${errorText}`);
      }
      const data = await response.json();
      console.log("Second file uploaded successfully:", data);

      SetErrorCodeTF(data.contentTF?.status);

      setRiverchainID(data.contentTF?.TRANSACTIONID ?? "");

      setBorroerNameEng(data.contentTF?.BORROWER);
      setLenderNo(
        data.contentTF?.LENDER_NO !== null ? data.contentTF?.LENDER_NO : ""
      );

      setProductNo(
        data.contentTF?.PRODUCT_NO !== null ? data.contentTF?.PRODUCT_NO : ""
      );

      setFacilityLimit(
        data.contentTF?.FACILITYLIMIT_HK !== null
          ? data.contentTF?.FACILITYLIMIT_HK
          : "00"
      );
      SetDrawDownAvailability(
        data.contentTF?.AVAILABILITYPERIOD_DAYS_MONTHS ?? ""
      );
      setInterestRate(
        data.contentTF?.INTERESTRATE !== null
          ? (data.contentTF?.INTERESTRATE * 100).toFixed(2)
          : "00.00"
      );
      setMaxTerm(
        data.contentTF?.MAXTERM_DAYS !== null
          ? data.contentTF?.MAXTERM_DAYS
          : "00.00"
      );
      setRepaymentOne(
        data.contentTF?.REPAYMENT_NO_1 !== null
          ? data.contentTF?.REPAYMENT_NO_1
          : ""
      );

      setInvoiceFinancing(
        data.contentTF?.DRAWDOWNLIMIT_PERCENTAGE_ !== null
          ? data.contentTF?.DRAWDOWNLIMIT_PERCENTAGE_
          : ""
      );

      setProjectDetails(
        data.contentTF?.MAINCONTRACT !== null
          ? data.contentTF?.MAINCONTRACT
          : ""
      );
      setContractStartDate(
        data.contentTF?.CONTRACTSTARTDATE !== null
          ? data.contentTF?.CONTRACTSTARTDATE
          : ""
      );
      setInvoiceNo(
        data.contentTF?.INVOICENO !== null ? data.contentTF?.INVOICENO : ""
      );

      setInvoiceNo2(
        data.contentTF?.INVOICENO_2 !== null ? data.contentTF?.INVOICENO_2 : ""
      );

      setInvoiceNo3(
        data.contentTF?.INVOICENO_3 !== null ? data.contentTF?.INVOICENO_3 : ""
      );

      setInvoiceAmount(
        data.contentTF?.INVOICEVALUE_HK !== null
          ? data.contentTF?.INVOICEVALUE_HK
          : ""
      );

      setInvoiceAmount2(
        data.contentTF?.INVOICEVALUE_HK_2 !== null
          ? data.contentTF?.INVOICEVALUE_HK_2
          : ""
      );

      const val =
        data.contentTF?.INVOICEVALUE_HK ??
        data.contentTF?.INVOICEVALUE_HK_2 ??
        "00.00";

      setInvoiceAmountFinal(val);

      setSubContractInvoiceAmount2(
        data.contentTF?.INVOICEVALUE_HK_2 !== null
          ? data.contentTF?.INVOICEVALUE_HK_2
          : ""
      );

      setSubContractInvoiceAmount3(
        data.contentTF?.INVOICEVALUE_HK_3 !== null
          ? data.contentTF?.INVOICEVALUE_HK_3
          : ""
      );

      setInvoiceDate(
        data.contentTF?.INVOICEDATE !== null ? data.contentTF?.INVOICEDATE : ""
      );

      setInvoiceDate2(
        data.contentTF?.INVOICEDATE_2 !== null
          ? data.contentTF?.INVOICEDATE_2
          : ""
      );

      setInvoiceDate3(
        data.contentTF?.INVOICEDATE_3 !== null
          ? data.contentTF?.INVOICEDATE_3
          : ""
      );

      setBorrowerContractor(data.contentTF?.MAINCONTRACTOR ?? "");
      setAdminFee(
        data.contentTF?.ADMINFEE !== null
          ? (data.contentTF?.ADMINFEE * 100).toFixed(2)
          : ""
      );
      setSubContractorNo(
        data.contentTF?.SUBCONTRACT !== null ? data.contentTF?.SUBCONTRACT : ""
      );
      setEmployer(
        data.contentTF?.EMPLOYER !== null ? data.contentTF?.EMPLOYER : ""
      );
      setContractType(
        data.contentTF?.CONTRACTTYPE_NO !== null
          ? data.contentTF?.CONTRACTTYPE_NO
          : ""
      );

      setContractType2(data.contentTF?.CONTRACTTYPE_NO_2 ?? "");

      setContractType3(
        data.contentTF?.CONTRACTTYPE_NO_3 !== null
          ? data.contentTF?.CONTRACTTYPE_NO_3
          : ""
      );

      setSubContractNo2(
        data.contentTF?.SUBCONTRACT_2 !== null
          ? data.contentTF?.SUBCONTRACT_2
          : ""
      );

      setSubContractNo3(
        data.contentTF?.SUBCONTRACT_3 !== null
          ? data.contentTF?.SUBCONTRACT_3
          : ""
      );

      setSubContractprojectDetails(
        data.contentTF?.MAINCONTRACT_2 !== null
          ? data.contentTF?.MAINCONTRACT_2
          : ""
      );

      setSubContractprojectDetails3(
        data.contentTF?.MAINCONTRACT_3 !== null
          ? data.contentTF?.MAINCONTRACT_3
          : ""
      );

      setSubContractStartDate(
        data.contentTF?.CONTRACTSTARTDATE_2 !== null
          ? data.contentTF?.CONTRACTSTARTDATE_2
          : ""
      );
      setSubContractStartDate3(
        data.contentTF?.CONTRACTSTARTDATE_3 !== null
          ? data.contentTF?.CONTRACTSTARTDATE_3
          : ""
      );
      setEmp2(
        data.contentTF?.EMPLOYER_2 !== null ? data.contentTF?.EMPLOYER_2 : ""
      );
      setEmp3(
        data.contentTF?.EMPLOYER_3 !== null ? data.contentTF?.EMPLOYER_3 : ""
      );
      setBorowwersContractor2(
        data.contentTF?.MAINCONTRACTOR_2 !== null
          ? data.contentTF?.MAINCONTRACTOR_2
          : ""
      );
      setBorowwersContractor3(
        data.contentTF?.MAINCONTRACTOR_3 !== null
          ? data.contentTF?.MAINCONTRACTOR_3
          : ""
      );
      setPaymentCertvalue(
        data.contentTF?.PAYMENTCERTVALUE_HK !== null
          ? data.contentTF?.PAYMENTCERTVALUE_HK
          : ""
      );

      const valCert = data.contentTF?.CERTIFIEDTODATE_EXCLVO_HK;
      console.log("valCert", valCert);

      setCertiCumValue(
        valCert != null
          ? (Math.round(Number(valCert) * 100) / 100).toFixed(2)
          : "00.00"
      );
      console.log("newcertiCumValue", certiCumValue);

      return true;
    } catch (error) {
      console.error("Error uploading second file:", error);
      setStatus("Upload failed, please check the uploaded file");
    }
  };

  useEffect(() => {
    console.log("Updated certiCumValue:", certiCumValue);
  }, [certiCumValue]);

  const handleUploadTFVerify = async () => {
    try {
      if (!file2) {
        console.error("Second file is missing!");
        setStatus("Please select the second file.");
        return;
      }
      const formData2 = new FormData();
      formData2.append("file", file2);

      console.log("Uploading second file...");
      const response = await fetch(`${BACKEND_URL}/uploadTFfileVersion8_7/`, {
        method: "POST",
        body: formData2,
        headers: { Accept: "application/json" },
      });

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(`Server error: ${response.status} - ${errorText}`);
      }
      const data = await response.json();
      console.log("Second file uploaded successfully-", data);
      setTransactionID(data.content?.TransactionID ?? "");

      if (product_type === "product_A") {
        setStatusTF("This is a Product A file!");
      }
      setLender_Purchaser(data.content?.LENDER_NO ?? "");
      setLoan_type_2_1(data.content?.loan_type_2_1 ?? "");
      setFacilityPrepaymentLimit(data.content?.Facility_PrepaymentLimit ?? "");
      setInterestRate8_7(
        convertRate(data.content?.InterestRate_DiscountCharge__percentage_pa)
      );

      setRepayment_2_1(data.content?.Repayment_2_1 ?? "");

      setInvoiceFinancing8_7(() => {
        const raw =
          data.content
            ?.DrawdownLimit_PrepaymentPercentage_percentage__Invoice_paymentcert;

        if (raw == null || raw === "") return "";

        // Step 1: Convert to number
        const num = Number(raw);

        // Step 2: Multiply by 100
        const multiplied = num * 100;

        // Step 3: Remove decimals
        return Math.floor(multiplied).toString();
      });

      setMainContractor(data.content?.MainContractor_orDebtor_Contract1 ?? "");

      setAdminFee_8_7(convertRate(data.content?.AdminFee_percentage_));
      setSubcontractProjectDetails1(
        data.content?.SubcontractDescription_Contract1 ?? ""
      );
      setContractStartDate1(
        formatDateDDMMMYYY(data.content?.ContractStartDate_Contract1)
      );
      setReceivableNo_01(data.content?.ReceivableNo_01 ?? "");
      setApplicationDate_01(
        formatDateDDMMMYYY(data.content?.ApplicationDate_01)
      );
      setApplicationDate_02(
        formatDateDDMMMYYY(data.content?.ApplicationDate_02)
      );
      setApplicationDate_03(
        formatDateDDMMMYYY(data.content?.ApplicationDate_03)
      );
      setApplicationValue_01(data.content?.ApplicationValue_01 ?? "");
      setEmployer_Contract1(data.content?.Employer_Contract1 ?? "");
      setContractType_Contract1_no(
        data.content?.ContractType_Contract1_no ?? ""
      );
      setReceivableNo_02(data.content?.ReceivableNo_02 ?? "");
      setReceivableNo_03(data.content?.ReceivableNo_03 ?? "");
      setApplicationValue_02(data.content?.ApplicationValue_02 ?? "");
      setApplicationValue_03(data.content?.ApplicationValue_03 ?? "");
      setCertificateNo_01(data.content?.CertificateNo_01 ?? "");
      setCertificateDate_01(
        formatDateDDMMMYYY(data.content?.setCertificateDate_01)
      );
      setCertificateIssueby_01(data.content?.CertificateIssueby_01 ?? "");
      setCertificateValue_01(data.content?.CertificateValue_01 ?? "");
      setCertificateValue_02(data.content?.CertificateValue_02 ?? "");
      setCertificateValue_03(data.content?.CertificateValue_03 ?? "");
      setCertifiedtoDate_exclVO1(data.content?.CertifiedtoDate_exclVO1 ?? "");

      setSubContractNo_Contract2(data.content?.SubContractNo_Contract2 ?? "");

      setContractStartDate_Contract2(
        formatDateDDMMMYYY(data.content?.ContractStartDate_Contract2)
      );

      setSubcontractDescription_Contract2(
        data.content?.SubcontractDescription_Contract2 ?? ""
      );

      setMainContractor_Contract2(data.content?.MainContractor_Contract2 ?? "");

      setCollectionAccount(data.content?.CollectionAccount_no ?? "");

      setDefaultInterestrate(
        convertRate(data.content?.DefaultInterestRate_percentage_)
      );
      setTranche1Limit(data.content?.Tranche1Limit ?? "");
      setTranche2Limit(data.content?.Tranche2Limit ?? "");
      setTranche3Limit(data.content?.Tranche3Limit ?? "");
      setSubContractNo_Contract3(data.content?.SubContractNo_Contract3 ?? "");

      setContractStartDate_Contract3(
        formatDateDDMMMYYY(data.content?.ContractStartDate_Contract3)
      );
      setSubcontractDescription_Contract3(
        data.content?.SubcontractDescription_Contract3 ?? ""
      );

      setEmployer_Contract2(data.content?.Employer_Contract2 ?? "");

      setEmployer_Contract3(data.content?.Employer_Contract3 ?? "");

      setContractType_Contract3(data.content?.ContractType_Contract3_no ?? "");

      setContractForm_Contract1(data.content?.ContractForm_Contract1 ?? "");

      setContractForm_Contract2(data.content?.ContractForm_Contract2 ?? "");

      setContractForm_Contract3(data.content?.ContractForm_Contract3 ?? "");

      setDateofFacilityLetter(data.content?.DateofFacilityLetter ?? "");
      setMaxTermofPayment_months(data.content?.MaxTermofPayment_months ?? "");
      setMaxTermofPayment_days(data.content?.MaxTermofPayment_days ?? "");
      setFacilityAvailabilityPeriod_days(
        data.content?.FacilityAvailabilityPeriod_days ?? ""
      );
      setFacilityAvailabilityPeriod_months(
        data.content?.FacilityAvailabilityPeriod_months ?? ""
      );
      setCurrency_symbol(data.content?.Currency_symbol ?? "");
      setSubContractNo_Contract1(data.content?.SubContractNo_Contract1 ?? "");
      setContractType_Contract2_no(
        data.content?.ContractType_Contract2_no ?? ""
      );
      setMainContractor_Contract3(data.content?.MainContractor_Contract3 ?? "");

      const value = data.content?.product_type ?? "";
      setProduct_type(value);
      return value;
    } catch (error) {
      console.error("Error uploading second file:", error);
      setStatus("Upload failed, please check the uploaded file");
    }
  };

  const handleUpload = async () => {
    if (!file || !file2) {
      setStatus("Please select both files before uploading.");
      return;
    }
    setLoading(true);
    setStatus("Uploading first file...2");

    if (errorCodeCC === "ERROR") {
      setLoading(true);
      console.log("Loading:", loading);
      return;
    }

    if (errorCodeTF === "ERROR") {
      setLoading(true);
      console.log("Loading:", loading);
      return;
    }

    const firstFileSuccess = await handleUploadCC();

    if (firstFileSuccess) {
      console.log("First upload successful, now uploading second file...");
      setStatus("Uploading second file...");
      setFinalUpload(true);
    } else {
      console.log("First upload failed, skipping second upload.");
    }

    setLoading(false);
  };

  useEffect(() => {
    if (errorCodeCC === "ERROR") {
      setStatus("Somethig wrong with the Transaction File");
      setLoading(true);
      console.log("Loading:", loading);
      return;
    }

    if (errorCodeTF === "ERROR") {
      setStatus("Somethig wrong with the Transaction File");
      setLoading(true);
      console.log("Loading:", loading);
      return;
    }

    // compantNameEng
    if (errorCodeCC === "OK") {
      const newStartDate =
        contractStartDate && contractStartDate !== null
          ? formatNewDate(contractStartDate)
          : "";

      const newInvoiceDate =
        invoiceDate && invoiceDate !== null ? formatNewDate(invoiceDate) : "";

      const newInvoiceDate2 =
        invoiceDate2 && invoiceDate2 !== null
          ? formatNewDate(invoiceDate2)
          : "";

      const newInvoiceDate3 =
        invoiceDate3 && invoiceDate3 !== null
          ? formatNewDate(invoiceDate3)
          : "";

      const newSubConStartDate =
        subContractStartDate && subContractStartDate !== null
          ? formatNewDate(subContractStartDate)
          : "";

      const newSubConStartDate3 =
        subContractStartDate3 && subContractStartDate3 !== null
          ? formatNewDate(subContractStartDate3)
          : "";

      const newsubContractNo2 = subContractNo2 ?? "";

      const newsubContractNo3 = subContractNo3 ?? "";

      const newborrowerContractor = borrowerContractor ?? "";

      const newBororwersContractor2 = borowwersContractor2 ?? "";

      const newBororwersContractor3 = borowwersContractor3 ?? "";

      const newsubContractorprojectDetails = subContractprojectDetails ?? "";

      const newsubContractorprojectDetails3 = subContractprojectDetails3 ?? "";

      const newpaymentCertvalue =
        paymentCertvalue && paymentCertvalue !== undefined
          ? paymentCertvalue
          : "";

      const newInvoiceNo = invoiceNo ?? invoiceNo2;

      const newContractType2 = contractType2 ?? "";

      const newInvoiceNo2 = invoiceNo2 ?? "";

      const newInvoiceNo3 = invoiceNo3 ?? "";

      const newemp2 = emp2 === undefined ? "" : emp2 !== null ? emp2 : "";

      const newemp3 = emp3 === undefined ? "" : emp3 !== null ? emp3 : "";

      const newriverchainID = riverchainID ?? "";

      const newInvoiceFinancing =
        invoiceFinancing && invoiceFinancing !== undefined
          ? invoiceFinancing * 100
          : "00";

      const newProNo = productNo && productNo !== undefined ? productNo : "";
      const newrepaymentOne =
        repaymentOne && repaymentOne !== undefined ? repaymentOne : "";
      const newcontractType =
        contractType && contractType !== undefined ? contractType : "";

      const newlenderNo = lenderNo && lenderNo !== undefined ? lenderNo : "";

      const NewmaxTerm = maxTerm && maxTerm !== undefined ? maxTerm : "00";
      const newinterestRate =
        interestRate && interestRate !== undefined ? interestRate : "00";
      const newinvoiceAmountFinal =
        invoiceAmountFinal && invoiceAmountFinal !== undefined
          ? invoiceAmountFinal
          : "00.00";

      const newcertiCumValue =
        certiCumValue && certiCumValue !== undefined ? certiCumValue : "00.00";

      const newfacilityLimit =
        facilityLimit && facilityLimit !== undefined ? facilityLimit : "00";

      const newadminFee = adminFee && adminFee !== undefined ? adminFee : "00";

      // for transaction file 8.7
      if (product_type === "product_B") {
        const xmlData = `<?xml version="1.0" encoding="UTF-8"?>
<isheet recordcount="string">
	<id>0</id>
	<title>string</title>
	<description>string</description>
	<status>string</status>
	<accesstype>string</accesstype>
	<type>string</type>
	<viewlink>string</viewlink>
	<allowsections>string</allowsections>
	<allowlookup>string</allowlookup>
	<displayisheet>string</displayisheet>
	<searchasdefaultview>string</searchasdefaultview>
	<enableversion>string</enableversion>
	<enablesheetalerter>string</enablesheetalerter>
	<alertercondition>string</alertercondition>
	<overrideitemmodifieddate>string</overrideitemmodifieddate>
	<enablebulkinsertupdate>string</enablebulkinsertupdate>
	<fielddescriptions>string</fielddescriptions>
	<enablerowlocking>string</enablerowlocking>
	<setcharlimittruncatemultilinetextenabled>string</setcharlimittruncatemultilinetextenabled>
	<setcharlimittruncatemultilinetextval>string</setcharlimittruncatemultilinetextval>
	<allowchoicelistvaluesforreuse>string</allowchoicelistvaluesforreuse>
	<allowscorelistvaluesforreuse>string</allowscorelistvaluesforreuse>
	<allowIsheetComments>string</allowIsheetComments>
	<shareRecordsLimit>0</shareRecordsLimit>
	<shareRecordsLimitEnabled>0</shareRecordsLimitEnabled>
	<enableIsheetAddRecordFormSharing>string</enableIsheetAddRecordFormSharing>
	<allowViewBaseRendering>string</allowViewBaseRendering>
	<columns>
		<column sequence="string" attributecolumnid="string">
			<columnid>0</columnid>
			<name>test</name>
			<type>0</type>
			<status>0</status>
			<systemgeneratedtype>string</systemgeneratedtype>
			<section>0</section>
			<description>string</description>
			<addtodefaultview>string</addtodefaultview>
			<columnconditionstate>string</columnconditionstate>
			<columnconditions>
				<row>
					<rowid>0</rowid>
					<columnid>0</columnid>
					<operatorid>0</operatorid>
					<oprand>string</oprand>
					<logicaltype>string</logicaltype>
					<sheetfiltervaluetypeid>string</sheetfiltervaluetypeid>
					<displaytype>string</displaytype>
					<scoreConditionTypeid>0</scoreConditionTypeid>
					<sourceColumnId>0</sourceColumnId>
				</row>
			</columnconditions>
			<columnspecificdetail>
				<defaultvalue>string</defaultvalue>
				<columnwidth>string</columnwidth>
				<sheetname>string</sheetname>
				<sitename>string</sitename>
				<mandatory>string</mandatory>
				<allowsearch>string</allowsearch>
				<maxchars>0</maxchars>
				<allowfieldfromanotherisheet>string</allowfieldfromanotherisheet>
				<allowrichhtmltext>string</allowrichhtmltext>
				<numberoflines>0</numberoflines>
				<displaymethod>string</displaymethod>
				<includeotheroption>string</includeotheroption>
				<singleormultileselectioninsearch>string</singleormultileselectioninsearch>
				<choices>
					<choice>
						<id>string</id>
						<label>string</label>
						<score>string</score>
						<color>string</color>
						<imageid>0</imageid>
					</choice>
				</choices>
				<includeinalertpreferences>string</includeinalertpreferences>
				<min>string</min>
				<max>string</max>
				<decimalplaces>0</decimalplaces>
				<showthousandseparators>string</showthousandseparators>
				<showaspercentage>string</showaspercentage>
				<symbolId>string</symbolId>
				<numberDecimalFormat>DOT_AS_DECIMAL/COMMA_AS_DECIMAL</numberDecimalFormat>
				<symbolPosition>before/after</symbolPosition>
				<formattype>string</formattype>
				<dateformat>string</dateformat>
				<defaultdateandtime>string</defaultdateandtime>
				<sheetlookup>string</sheetlookup>
				<fielddisplay>string</fielddisplay>
				<allowmultipleusers>string</allowmultipleusers>
				<methodtype>string</methodtype>
				<sheetids>string</sheetids>
				<allowuserstorenamelinks>string</allowuserstorenamelinks>
				<sheetid>0</sheetid>
				<columnids>string</columnids>
				<viewid>0</viewid>
				<allowmultiplevalues>string</allowmultiplevalues>
				<restrictdelete>string</restrictdelete>
				<displaycolumnnameprefix>string</displaycolumnnameprefix>
				<linkname>string</linkname>
				<donotcountweekendsonlycountmontofri>string</donotcountweekendsonlycountmontofri>
				<joinconditions>
					<joincondition>
						<currentsheetcolumnid>0</currentsheetcolumnid>
						<targetsheetcolumnid>0</targetsheetcolumnid>
					</joincondition>
				</joinconditions>
				<formula>string</formula>
				<startvalue>0</startvalue>
				<prefix>string</prefix>
				<postfix>string</postfix>
				<minlength>0</minlength>
				<lookupglossarysheetid>0</lookupglossarysheetid>
				<lookupglossarysheetviewid>0</lookupglossarysheetviewid>
				<width>0</width>
				<otherscorevalue>string</otherscorevalue>
				<importdatafromexternalsource>string</importdatafromexternalsource>
				<analysisengine>string</analysisengine>
				<attachmentcustomfolderid/>
				<singleLineEmailValidation>string</singleLineEmailValidation>
				<readonly>string</readonly>
				<virtualColumn>0</virtualColumn>
				<externalSource>string</externalSource>
				<allowInlineEditing>string</allowInlineEditing>
			</columnspecificdetail>
			<rawdata>
				<value>string</value>
				<choices>
					<choice>
						<id>string</id>
						<label>string</label>
						<score>string</score>
						<color>string</color>
						<imageid>0</imageid>
					</choice>
				</choices>
				<date>string</date>
				<time>string</time>
				<linkdisplayname>string</linkdisplayname>
				<linkdisplayurl>string</linkdisplayurl>
				<lookups>
					<lookup>
						<id>string</id>
						<email>string</email>
						<userlookuptype>string</userlookuptype>
					</lookup>
				</lookups>
				<folders>
					<folder>
						<folderid>string</folderid>
					</folder>
				</folders>
				<documents>
					<document>
						<docid>string</docid>
					</document>
				</documents>
				<fromdate>string</fromdate>
				<todate>string</todate>
				<attachments>
					<attachment>
						<file>string</file>
						<name>string</name>
						<order>string</order>
						<id>0</id>
						<extension>string</extension>
						<parentfolderid>0</parentfolderid>
						<filehttplink>string</filehttplink>
						<folderpath>string</folderpath>
						<folderhttplink>string</folderhttplink>
						<filesize>0</filesize>
						<redactionstatus>true</redactionstatus>
						<siteid>0</siteid>
						<displayname>string</displayname>
					</attachment>
				</attachments>
				<isheetitems>
					<isheetitem>
						<recordid>string</recordid>
						<linkname>string</linkname>
						<apilink>string</apilink>
						<httplink>string</httplink>
					</isheetitem>
				</isheetitems>
				<daydifference>string</daydifference>
			</rawdata>
			<colViewPosition>0</colViewPosition>
			<columntype>string</columntype>
			<createdDate>2025-11-20T15:17:34.153Z</createdDate>
			<modifiedDate>2025-11-20T15:17:34.153Z</modifiedDate>
			<injectReferenceColumn>0</injectReferenceColumn>
			<parentColumnID>0</parentColumnID>
			<reusecolumnidfromisheet>0</reusecolumnidfromisheet>
			<choicelistid>0</choicelistid>
			<editpermission>0</editpermission>
			<templatesheetcolumnid>0</templatesheetcolumnid>
			<uploadpermission>0</uploadpermission>
			<deletepermission>0</deletepermission>
			<sourceSheetID>0</sourceSheetID>
		</column>
	</columns>
	<metadata>
		<viewName>string</viewName>
		<viewId>0</viewId>
		<siteName>string</siteName>
		<siteId>0</siteId>
		<sheetId>0</sheetId>
		<sheetName>string</sheetName>
	</metadata>
	<head>
      <headcolumn sequence="1" columntypealias="SHEET_COLUMN_TYPE_LOOKUP" columntypeid="6" columnid="2716">
        <columnvalue><![CDATA[Created by]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="2" columntypealias="SHEET_COLUMN_TYPE_DATE_AND_TIME" columntypeid="5" columnid="2717">
        <columnvalue><![CDATA[Created date]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="3" columntypealias="SHEET_COLUMN_TYPE_LOOKUP" columntypeid="6" columnid="2718">
        <columnvalue><![CDATA[Modified by]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="4" columntypealias="SHEET_COLUMN_TYPE_DATE_AND_TIME" columntypeid="5" columnid="2719">
        <columnvalue><![CDATA[Modified date]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="5" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="2720">
        <columnvalue><![CDATA[Riverchain ID]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="6" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="2721">
        <columnvalue><![CDATA[Borrower Name English]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="7" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="2722">
        <columnvalue><![CDATA[Borrower Name Chinese]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="8" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="2723">
        <columnvalue><![CDATA[Borrower BR No.]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="9" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="2724">
        <columnvalue><![CDATA[Borrower Contact Details - Person]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="10" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="2725">
        <columnvalue><![CDATA[Borrower Contact Details - Phone]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="11" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="2726">
        <columnvalue><![CDATA[Borrower Contact Details - Email]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="12" columntypealias="SHEET_COLUMN_TYPE_MULTIPLE_LINE_TEXT" columntypeid="2" columnid="2727">
        <columnvalue><![CDATA[Borrower Address]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="13" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="2728">
        <columnvalue><![CDATA[Borrower Place of Incorporation]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="14" columntypealias="SHEET_COLUMN_TYPE_CHOICE" columntypeid="3" columnid="2729">
        <columnvalue><![CDATA[Lender Company Name]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="15" columntypealias="SHEET_COLUMN_TYPE_CHOICE" columntypeid="3" columnid="2730">
        <columnvalue><![CDATA[Loan Type (2.1)]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="16" columntypealias="SHEET_COLUMN_TYPE_CHOICE" columntypeid="3" columnid="2731">
        <columnvalue><![CDATA[Loan Type 2.2]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="17" columntypealias="SHEET_COLUMN_TYPE_NUMBER" columntypeid="4" columnid="2732">
        <columnvalue><![CDATA[Facility Limit (2.1)]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="18" columntypealias="SHEET_COLUMN_TYPE_NUMBER" columntypeid="4" columnid="2733">
        <columnvalue><![CDATA[Facility Limit (2.2)]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="19" columntypealias="SHEET_COLUMN_TYPE_NUMBER" columntypeid="4" columnid="2736">
        <columnvalue><![CDATA[Interest Rates]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="20" columntypealias="SHEET_COLUMN_TYPE_NUMBER" columntypeid="4" columnid="2737">
        <columnvalue><![CDATA[HIBOR Interest Rates]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="21" columntypealias="SHEET_COLUMN_TYPE_CHOICE" columntypeid="3" columnid="2738">
        <columnvalue><![CDATA[Repayment Type (2.1)]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="22" columntypealias="SHEET_COLUMN_TYPE_CHOICE" columntypeid="3" columnid="2739">
        <columnvalue><![CDATA[Repayment Type 2]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="23" columntypealias="SHEET_COLUMN_TYPE_NUMBER" columntypeid="4" columnid="2740">
        <columnvalue><![CDATA[Invoice amount]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="24" columntypealias="SHEET_COLUMN_TYPE_NUMBER" columntypeid="4" columnid="2741">
        <columnvalue><![CDATA[Invoice Financing %]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="25" columntypealias="SHEET_COLUMN_TYPE_MULTIPLE_LINE_TEXT" columntypeid="2" columnid="2742">
        <columnvalue><![CDATA[Borrower's Contractor]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="26" columntypealias="SHEET_COLUMN_TYPE_NUMBER" columntypeid="4" columnid="2743">
        <columnvalue><![CDATA[Admin Fee]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="27" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="2744">
        <columnvalue><![CDATA[Sub Contract No. (1)]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="28" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="2745">
        <columnvalue><![CDATA[Sub Contract Project Details (1)]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="29" columntypealias="SHEET_COLUMN_TYPE_DATE_AND_TIME" columntypeid="5" columnid="2746">
        <columnvalue><![CDATA[sub contract date (1)]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="30" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="2747">
        <columnvalue><![CDATA[Sub Contract Invoice No (1)]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="31" columntypealias="SHEET_COLUMN_TYPE_DATE_AND_TIME" columntypeid="5" columnid="2748">
        <columnvalue><![CDATA[Sub contract Invoice date (1)]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="32" columntypealias="SHEET_COLUMN_TYPE_NUMBER" columntypeid="4" columnid="2749">
        <columnvalue><![CDATA[Sub contract invoice amount (1)]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="33" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="2750">
        <columnvalue><![CDATA[Borrower's Bank Name]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="34" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="2751">
        <columnvalue><![CDATA[Borrower's Bank Account No.]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="35" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="2752">
        <columnvalue><![CDATA[Borrower's Bank Account Name]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="36" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="2753">
        <columnvalue><![CDATA[Borrower's Bank Swift Code]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="37" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="2754">
        <columnvalue><![CDATA[Borrower's Emoloyer (1)]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="38" columntypealias="SHEET_COLUMN_TYPE_CHOICE" columntypeid="3" columnid="2755">
        <columnvalue><![CDATA[Contract Type (1)]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="39" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="2756">
        <columnvalue><![CDATA[Payment Application No.]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="40" columntypealias="SHEET_COLUMN_TYPE_NUMBER" columntypeid="4" columnid="2757">
        <columnvalue><![CDATA[Payment Application Amount]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="41" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="2758">
        <columnvalue><![CDATA[Collection Agent signor name]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="42" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="2759">
        <columnvalue><![CDATA[Collection Agent signor title]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="43" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="2760">
        <columnvalue><![CDATA[Lender Company signor name]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="44" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="2761">
        <columnvalue><![CDATA[Lender company signor title]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="45" columntypealias="SHEET_COLUMN_TYPE_CHOICE" columntypeid="3" columnid="2762">
        <columnvalue><![CDATA[Collect Agent company name]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="46" columntypealias="SHEET_COLUMN_TYPE_DATE_AND_TIME" columntypeid="5" columnid="2763">
        <columnvalue><![CDATA[Payment Application date]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="47" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="2764">
        <columnvalue><![CDATA[Payment Certificate Number]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="48" columntypealias="SHEET_COLUMN_TYPE_DATE_AND_TIME" columntypeid="5" columnid="2765">
        <columnvalue><![CDATA[Payment Certificate Date]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="49" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="2766">
        <columnvalue><![CDATA[Payment Certificate issued by]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="50" columntypealias="SHEET_COLUMN_TYPE_NUMBER" columntypeid="4" columnid="2767">
        <columnvalue><![CDATA[Payment certificate amount (1)]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="51" columntypealias="SHEET_COLUMN_TYPE_NUMBER" columntypeid="4" columnid="2768">
        <columnvalue><![CDATA[Payment Certificate amount (Cumulative)]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="52" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="2769">
        <columnvalue><![CDATA[Extension Approved Notice Period]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="53" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="2770">
        <columnvalue><![CDATA[Extension Request Notice Period]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="54" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="2771">
        <columnvalue><![CDATA[Maximum no. of extensions]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="55" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="2772">
        <columnvalue><![CDATA[Number of extensions]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="56" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="2773">
        <columnvalue><![CDATA[Supplier invoice issue no of days]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="57" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="2774">
        <columnvalue><![CDATA[Term/Revolving Loan Purpose]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="58" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="2775">
        <columnvalue><![CDATA[Term/Revolving Loan Drawdown Availability]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="59" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="2776">
        <columnvalue><![CDATA[Name of Security Provider]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="60" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="2777">
        <columnvalue><![CDATA[Conditions Subsequent Documents Delivery]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="61" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="2778">
        <columnvalue><![CDATA[Sub Contract No. (2)]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="62" columntypealias="SHEET_COLUMN_TYPE_DATE_AND_TIME" columntypeid="5" columnid="2779">
        <columnvalue><![CDATA[Sub Contract Date (2)]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="63" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="2780">
        <columnvalue><![CDATA[Sub Contract Project Details (2)]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="64" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="2781">
        <columnvalue><![CDATA[Borrower's Contractor (2)]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="65" columntypealias="SHEET_COLUMN_TYPE_CHOICE" columntypeid="3" columnid="2782">
        <columnvalue><![CDATA[Collection Account Required]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="66" columntypealias="SHEET_COLUMN_TYPE_CHOICE" columntypeid="3" columnid="2784">
        <columnvalue><![CDATA[Voluntary Prepayment Notice Period]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="67" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="2785">
        <columnvalue><![CDATA[Borrower's Bank Code]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="68" columntypealias="SHEET_COLUMN_TYPE_CHOICE" columntypeid="3" columnid="2786">
        <columnvalue><![CDATA[Repayment Currency]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="69" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="2787">
        <columnvalue><![CDATA[Tranche 1 Drawdown days]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="70" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="2788">
        <columnvalue><![CDATA[Tranche 2 Drawdown days]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="71" columntypealias="SHEET_COLUMN_TYPE_NUMBER" columntypeid="4" columnid="2789">
        <columnvalue><![CDATA[Default Interest Rate]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="72" columntypealias="SHEET_COLUMN_TYPE_NUMBER" columntypeid="4" columnid="2790">
        <columnvalue><![CDATA[Term Loan Tranche 1]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="73" columntypealias="SHEET_COLUMN_TYPE_NUMBER" columntypeid="4" columnid="2791">
        <columnvalue><![CDATA[Term Loan Tranche 2]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="74" columntypealias="SHEET_COLUMN_TYPE_NUMBER" columntypeid="4" columnid="2792">
        <columnvalue><![CDATA[Revenue Based Repaymentment Invoice Amount Percentage]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="75" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="2793">
        <columnvalue><![CDATA[Sub Contract No. (3)]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="76" columntypealias="SHEET_COLUMN_TYPE_DATE_AND_TIME" columntypeid="5" columnid="2794">
        <columnvalue><![CDATA[Sub Contract Date (3)]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="77" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="2795">
        <columnvalue><![CDATA[Sub Contract Project Details (3)]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="78" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="2796">
        <columnvalue><![CDATA[Borrower's Contractor (3)]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="79" columntypealias="SHEET_COLUMN_TYPE_CHOICE" columntypeid="3" columnid="2797">
        <columnvalue><![CDATA[Contract Type (2)]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="80" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="2798">
        <columnvalue><![CDATA[Borrower's Emoloyer (2)]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="81" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="2799">
        <columnvalue><![CDATA[Borrower's Emoloyer (3)]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="82" columntypealias="SHEET_COLUMN_TYPE_CHOICE" columntypeid="3" columnid="2800">
        <columnvalue><![CDATA[Contract Type (3)]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="83" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="2801">
        <columnvalue><![CDATA[Sub Contract Invoice No (2)]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="84" columntypealias="SHEET_COLUMN_TYPE_DATE_AND_TIME" columntypeid="5" columnid="2802">
        <columnvalue><![CDATA[Sub contract Invoice date (2)]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="85" columntypealias="SHEET_COLUMN_TYPE_NUMBER" columntypeid="4" columnid="2803">
        <columnvalue><![CDATA[Sub contract invoice amount (2)]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="86" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="2804">
        <columnvalue><![CDATA[Sub Contract Invoice No (3)]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="87" columntypealias="SHEET_COLUMN_TYPE_DATE_AND_TIME" columntypeid="5" columnid="2805">
        <columnvalue><![CDATA[Sub contract Invoice date (3)]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="88" columntypealias="SHEET_COLUMN_TYPE_NUMBER" columntypeid="4" columnid="2806">
        <columnvalue><![CDATA[Sub contract invoice amount (3)]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="89" columntypealias="SHEET_COLUMN_TYPE_CHOICE" columntypeid="3" columnid="2807">
        <columnvalue><![CDATA[Sole/Multiple Director]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="90" columntypealias="SHEET_COLUMN_TYPE_NUMBER" columntypeid="4" columnid="2808">
        <columnvalue><![CDATA[Payment certificate amount (2)]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="91" columntypealias="SHEET_COLUMN_TYPE_NUMBER" columntypeid="4" columnid="2809">
        <columnvalue><![CDATA[Payment certificate amount (3)]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="92" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="2810">
        <columnvalue><![CDATA[Borrower Contact Details - Title]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="93" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="2811">
        <columnvalue><![CDATA[Borrower Contact Details - Person Chinese Name]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="94" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="2812">
        <columnvalue><![CDATA[RC Authorised Person Name]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="95" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="2813">
        <columnvalue><![CDATA[RC Authorised Person HKID]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="96" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="2814">
        <columnvalue><![CDATA[RC Authorised Person Contact No.]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="97" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="2815">
        <columnvalue><![CDATA[Individual Guarantor ID Type]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="98" columntypealias="SHEET_COLUMN_TYPE_NUMBER" columntypeid="4" columnid="2816">
        <columnvalue><![CDATA[Final Maturity Period (months)]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="99" columntypealias="SHEET_COLUMN_TYPE_NUMBER" columntypeid="4" columnid="2817">
        <columnvalue><![CDATA[Final Maturity Period (days)]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="100" columntypealias="SHEET_COLUMN_TYPE_DATE_AND_TIME" columntypeid="5" columnid="2818">
        <columnvalue><![CDATA[Facility Letter Date]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="101" columntypealias="SHEET_COLUMN_TYPE_NUMBER" columntypeid="4" columnid="2819">
        <columnvalue><![CDATA[Drawdown Availability Period (days)]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="102" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="2820">
        <columnvalue><![CDATA[Drawdown Availability Period (months)]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="103" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="2821">
        <columnvalue><![CDATA[Contract Form (1)]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="104" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="2822">
        <columnvalue><![CDATA[Contract Form (2)]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="105" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="2823">
        <columnvalue><![CDATA[Contract Form (3)]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="106" columntypealias="SHEET_COLUMN_TYPE_NUMBER" columntypeid="4" columnid="2824">
        <columnvalue><![CDATA[Term Loan Tranche 3]]></columnvalue>
      </headcolumn>
    </head>
	<data>
	<item externalid="" itemsequence="1" itemid="1">
	 	    <column sequence="5" attributecolumnid="2720">
          <rawdata>
            <value><![CDATA[${TransactionID}]]></value>
          </rawdata>
          <displaydata>
            <value><![CDATA[${TransactionID}]]></value>
          </displaydata>
        </column>
        <column sequence="6" attributecolumnid="2721">
          <rawdata>
            <value><![CDATA[${companyNameInEnglish}]]></value>
          </rawdata>
          <displaydata>
            <value><![CDATA[${companyNameInEnglish}]]></value>
          </displaydata>
        </column>
        <column sequence="7" attributecolumnid="2722">
          <rawdata>
            <value><![CDATA[${companyNameInChinese}]]></value>
          </rawdata>
          <displaydata>
            <value><![CDATA[${companyNameInChinese}]]></value>
          </displaydata>
        </column>
        <column sequence="8" attributecolumnid="2723">
          <rawdata>
            <value><![CDATA[${businessRegistrationNumber}]]></value>
          </rawdata>
          <displaydata>
            <value><![CDATA[${businessRegistrationNumber}]]></value>
          </displaydata>
        </column>
        <column sequence="9" attributecolumnid="2724">
          <rawdata>
            <value><![CDATA[${contactnameFirstAndLast}]]></value>
          </rawdata>
          <displaydata>
            <value><![CDATA[${contactnameFirstAndLast}]]></value>
          </displaydata>
        </column>
        <column sequence="10" attributecolumnid="2725">
          <rawdata>
            <value><![CDATA[${contactphonenumber}]]></value>
          </rawdata>
          <displaydata>
            <value><![CDATA[${contactphonenumber}]]></value>
          </displaydata>
        </column>
        <column sequence="11" attributecolumnid="2726">
          <rawdata>
            <value><![CDATA[${contactemailaddress}]]></value>
          </rawdata>
          <displaydata>
            <value><![CDATA[${contactemailaddress}]]></value>
          </displaydata>
        </column>
        <column sequence="12" attributecolumnid="2727">
          <rawdata>
            <value><![CDATA[${registeredAddress}]]></value>
          </rawdata>
          <displaydata>
            <value><![CDATA[${registeredAddress}]]></value>
          </displaydata>
        </column>
        <column sequence="13" attributecolumnid="2728">
          <rawdata>
            <value><![CDATA[${placeofincorporation}]]></value>
          </rawdata>
          <displaydata>
            <value><![CDATA[${placeofincorporation}]]></value>
          </displaydata>
        </column>
        <column sequence="14" attributecolumnid="2729">
          <rawdata>
            <choices>
              <choice>
                  <id>${Lender_Purchaser}</id>
              </choice>
            </choices>
            </rawdata>
        </column>
        <column sequence="15" attributecolumnid="2730">
          <rawdata>
            <choices>
              <choice>
                  <id>${loan_type_2_1}</id>
              </choice>
            </choices>
            </rawdata>
        </column>
        <column sequence="17" attributecolumnid="2732">
          <rawdata>
            <value><![CDATA[${facilityPrepaymentLimit}]]></value>
          </rawdata>
          <displaydata>
            <value><![CDATA[${facilityPrepaymentLimit}]]></value>
          </displaydata>
        </column>
        <column sequence="19" attributecolumnid="2736">
          <rawdata>
            <value><![CDATA[${interestRate8_7}]]></value>
          </rawdata>
          <displaydata>
            <value><![CDATA[${interestRate8_7}]]></value>
          </displaydata>
        </column>

        <column sequence="21" attributecolumnid="2738">
          <rawdata>
            <choices>
              <choice>
                  <id>${Repayment_2_1}</id>
              </choice>
            </choices>
            </rawdata>
        </column>
        <column sequence="23" attributecolumnid="2740">
          <rawdata>
            <value><![CDATA[${applicationValue_01}]]></value>
          </rawdata>
          <displaydata>
            <value><![CDATA[${applicationValue_01}]]></value>
          </displaydata>
        </column>

        <column sequence="24" attributecolumnid="2741">
          <rawdata>
            <value><![CDATA[${invoiceFinancing8_7}]]></value>
          </rawdata>
          <displaydata>
            <value><![CDATA[${invoiceFinancing8_7}]]></value>
          </displaydata>
        </column>
        <column sequence="25" attributecolumnid="2742">
          <rawdata>
            <value><![CDATA[${mainContractor}]]></value>
          </rawdata>
          <displaydata>
            <value><![CDATA[${mainContractor}]]></value>
          </displaydata>
        </column>
        <column sequence="26" attributecolumnid="2743">
          <rawdata>
            <value><![CDATA[${adminFee8_7}]]></value>
          </rawdata>
          <displaydata>
            <value><![CDATA[${adminFee8_7}]]></value>
          </displaydata>
        </column>
        <column sequence="27" attributecolumnid="2744">
          <rawdata>
            <value><![CDATA[${subContractNo_Contract1}]]></value>
          </rawdata>
          <displaydata>
            <value><![CDATA[${subContractNo_Contract1}]]></value>
          </displaydata>
        </column>
        <column sequence="28" attributecolumnid="2745">
          <rawdata>
            <value><![CDATA[${subcontractProjectDetails1}]]></value>
          </rawdata>
          <displaydata>
            <value><![CDATA[${subcontractProjectDetails1}]]></value>
          </displaydata>
        </column>
        <column sequence="29" attributecolumnid="2746">
          <rawdata>
            <value><![CDATA[${contractStartDate1}]]></value>
          </rawdata>
          <displaydata>
            <value><![CDATA[${contractStartDate1}]]></value>
          </displaydata>
        </column>
        <column sequence="30" attributecolumnid="2747">
          <rawdata>
            <value><![CDATA[${receivableNo_01}]]></value>
          </rawdata>
          <displaydata>
            <value><![CDATA[${receivableNo_01}]]></value>
          </displaydata>
        </column>
        <column sequence="31" attributecolumnid="2748">
          <rawdata>
            <value><![CDATA[${applicationDate_01}]]></value>
          </rawdata>
          <displaydata>
            <value><![CDATA[${applicationDate_01}]]></value>
          </displaydata>
        </column>
        <column sequence="32" attributecolumnid="2749">
          <rawdata>
            <value><![CDATA[${applicationValue_01}]]></value>
          </rawdata>
          <displaydata>
            <value><![CDATA[${applicationValue_01}]]></value>
          </displaydata>
        </column>
        <column sequence="33" attributecolumnid="2750">
          <rawdata>
            <value><![CDATA[${bankName}]]></value>
          </rawdata>
          <displaydata>
            <value><![CDATA[${bankName}]]></value>
          </displaydata>
        </column>
        <column sequence="34" attributecolumnid="2751">
          <rawdata>
            <value><![CDATA[${bankAccNo}]]></value>
          </rawdata>
          <displaydata>
            <value><![CDATA[${bankAccNo}]]></value>
          </displaydata>
        </column>
        <column sequence="35" attributecolumnid="2752">
          <rawdata>
            <value><![CDATA[${benifiserName}]]></value>
          </rawdata>
          <displaydata>
            <value><![CDATA[${benifiserName}]]></value>
          </displaydata>
        </column>
        <column sequence="36" attributecolumnid="2753">
          <rawdata>
            <value><![CDATA[${swift}]]></value>
          </rawdata>
          <displaydata>
            <value><![CDATA[${swift}]]></value>
          </displaydata>
        </column>
        <column sequence="37" attributecolumnid="2754">
          <rawdata>
            <value><![CDATA[${employer_Contract1}]]></value>
          </rawdata>
          <displaydata>
            <value><![CDATA[${employer_Contract1}]]></value>
          </displaydata>
        </column>
         <column sequence="38" attributecolumnid="2755">
          <rawdata>
            <choices>
              <choice>
                  <id>${contractType_Contract1_no}</id>
              </choice>
            </choices>
            </rawdata>
        </column>
        <column sequence="39" attributecolumnid="2756">
          <rawdata>
            <value><![CDATA[${receivableNo_03}]]></value>
          </rawdata>
          <displaydata>
            <value><![CDATA[${receivableNo_03}]]></value>
          </displaydata>
        </column>
        <column sequence="40" attributecolumnid="2757">
          <rawdata>
            <value><![CDATA[${applicationValue_02}]]></value>
          </rawdata>
          <displaydata>
            <value><![CDATA[${applicationValue_02}]]></value>
          </displaydata>
        </column>
        <column sequence="46" attributecolumnid="2763">
          <rawdata>
            <value><![CDATA[${applicationDate_01}]]></value>
          </rawdata>
          <displaydata>
            <value><![CDATA[${applicationDate_01}]]></value>
          </displaydata>
        </column>
        <column sequence="47" attributecolumnid="2764">
          <rawdata>
            <value><![CDATA[${certificateNo_01}]]></value>
          </rawdata>
          <displaydata>
            <value><![CDATA[${certificateNo_01}]]></value>
          </displaydata>
        </column>
        <column sequence="48" attributecolumnid="2765">
          <rawdata>
            <value><![CDATA[${certificateDate_01}]]></value>
          </rawdata>
          <displaydata>
            <value><![CDATA[${certificateDate_01}]]></value>
          </displaydata>
        </column>
        <column sequence="49" attributecolumnid="2766">
          <rawdata>
            <value><![CDATA[${certificateIssueby_01}]]></value>
          </rawdata>
          <displaydata>
            <value><![CDATA[${certificateIssueby_01}]]></value>
          </displaydata>
        </column>
        <column sequence="50" attributecolumnid="2767">
          <rawdata>
            <value><![CDATA[${certificateValue_01}]]></value>
          </rawdata>
          <displaydata>
            <value><![CDATA[${certificateValue_01}]]></value>
          </displaydata>
        </column>
         <column sequence="51" attributecolumnid="2768">
          <rawdata>
            <value><![CDATA[${certifiedtoDate_exclVO1}]]></value>
          </rawdata>
          <displaydata>
            <value><![CDATA[${certifiedtoDate_exclVO1}]]></value>
          </displaydata>
        </column>
        <column sequence="61" attributecolumnid="2778">
          <rawdata>
            <value><![CDATA[${subContractNo_Contract2}]]></value>
          </rawdata>
          <displaydata>
            <value><![CDATA[${subContractNo_Contract2}]]></value>
          </displaydata>
        </column>

        <column sequence="62" attributecolumnid="2779">
          <rawdata>
            <value><![CDATA[${contractStartDate_Contract2}]]></value>
          </rawdata>
          <displaydata>
            <value><![CDATA[${contractStartDate_Contract2}]]></value>
          </displaydata>
        </column>

        <column sequence="63" attributecolumnid="2780">
          <rawdata>
            <value><![CDATA[${subcontractDescription_Contract2}]]></value>
          </rawdata>
          <displaydata>
            <value><![CDATA[${subcontractDescription_Contract2}]]></value>
          </displaydata>
        </column>

        <column sequence="64" attributecolumnid="2781">
          <rawdata>
            <value><![CDATA[${mainContractor_Contract2}]]></value>
          </rawdata>
          <displaydata>
            <value><![CDATA[${mainContractor_Contract2}]]></value>
          </displaydata>
        </column>
        <column sequence="65" attributecolumnid="2782">
          <rawdata>
            <choices>
              <choice>
                  <id>${collectionAccount}</id>
              </choice>
            </choices>
            </rawdata>
        </column>
        <column sequence="67" attributecolumnid="2785">
          <rawdata>
            <value><![CDATA[${bankCode}]]></value>
          </rawdata>
          <displaydata>
            <value><![CDATA[${bankCode}]]></value>
          </displaydata>
        </column>
        <column sequence="68" attributecolumnid="2786">
          <rawdata>
            <choices>
              <choice>
                  <id>${currency_symbol}</id>
              </choice>
            </choices>
            </rawdata>
        </column>
        <column sequence="15" attributecolumnid="2730">
          <rawdata>
            <choices>
              <choice>
                  <id>${loan_type_2_1}</id>
              </choice>
            </choices>
            </rawdata>
        </column>

        <column sequence="71" attributecolumnid="2789">
          <rawdata>
            <value><![CDATA[${defaultInterestRate}]]></value>
          </rawdata>
          <displaydata>
            <value><![CDATA[${defaultInterestRate}]]></value>
          </displaydata>
        </column>
        <column sequence="72" attributecolumnid="2790">
          <rawdata>
            <value><![CDATA[${tranche1Limit}]]></value>
          </rawdata>
          <displaydata>
            <value><![CDATA[${tranche1Limit}]]></value>
          </displaydata>
        </column>
        <column sequence="73" attributecolumnid="2791">
          <rawdata>
            <value><![CDATA[${tranche2Limit}]]></value>
          </rawdata>
          <displaydata>
            <value><![CDATA[${tranche2Limit}]]></value>
          </displaydata>
        </column>
        <column sequence="75" attributecolumnid="2793">
          <rawdata>
            <value><![CDATA[${subContractNo_Contract3}]]></value>
          </rawdata>
          <displaydata>
            <value><![CDATA[${subContractNo_Contract3}]]></value>
          </displaydata>
        </column>
        <column sequence="76" attributecolumnid="2794">
          <rawdata>
            <value><![CDATA[${ContractStartDate_Contract3}]]></value>
          </rawdata>
          <displaydata>
            <value><![CDATA[${ContractStartDate_Contract3}]]></value>
          </displaydata>
        </column>
        <column sequence="77" attributecolumnid="2795">
          <rawdata>
            <value><![CDATA[${subcontractDescription_Contract3}]]></value>
          </rawdata>
          <displaydata>
            <value><![CDATA[${subcontractDescription_Contract3}]]></value>
          </displaydata>
        </column>
        <column sequence="78" attributecolumnid="2796">
          <rawdata>
            <value><![CDATA[${mainContractor_Contract3}]]></value>
          </rawdata>
          <displaydata>
            <value><![CDATA[${mainContractor_Contract3}]]></value>
          </displaydata>
        </column>
        <column sequence="79" attributecolumnid="2797">
          <rawdata>
            <choices>
              <choice>
                  <id>${contractType_Contract2_no}</id>
              </choice>
            </choices>
            </rawdata>
        </column>
        <column sequence="80" attributecolumnid="2798">
          <rawdata>
            <value><![CDATA[${employer_Contract2}]]></value>
          </rawdata>
          <displaydata>
            <value><![CDATA[${employer_Contract2}]]></value>
          </displaydata>
        </column>
        <column sequence="81" attributecolumnid="2799">
          <rawdata>
            <value><![CDATA[${employer_Contract3}]]></value>
          </rawdata>
          <displaydata>
            <value><![CDATA[${employer_Contract3}]]></value>
          </displaydata>
        </column>
        <column sequence="83" attributecolumnid="2801">
          <rawdata>
            <value><![CDATA[${receivableNo_02}]]></value>
          </rawdata>
          <displaydata>
            <value><![CDATA[${receivableNo_02}]]></value>
          </displaydata>
        </column>
        <column sequence="84" attributecolumnid="2802">
          <rawdata>
            <value><![CDATA[${applicationDate_02}]]></value>
          </rawdata>
          <displaydata>
            <value><![CDATA[${applicationDate_02}]]></value>
          </displaydata>
        </column>
        <column sequence="85" attributecolumnid="2803">
          <rawdata>
            <value><![CDATA[${applicationValue_02}]]></value>
          </rawdata>
          <displaydata>
            <value><![CDATA[${applicationValue_02}]]></value>
          </displaydata>
        </column>
         <column sequence="86" attributecolumnid="2804">
          <rawdata>
            <value><![CDATA[${receivableNo_03}]]></value>
          </rawdata>
          <displaydata>
            <value><![CDATA[${receivableNo_03}]]></value>
          </displaydata>
        </column>
        <column sequence="87" attributecolumnid="2805">
          <rawdata>
            <value><![CDATA[${applicationDate_03}]]></value>
          </rawdata>
          <displaydata>
            <value><![CDATA[${applicationDate_03}]]></value>
          </displaydata>
        </column>
        <column sequence="88" attributecolumnid="2806">
          <rawdata>
            <value><![CDATA[${applicationValue_03}]]></value>
          </rawdata>
          <displaydata>
            <value><![CDATA[${applicationValue_03}]]></value>
          </displaydata>
        </column>
        <column sequence="90" attributecolumnid="2808">
          <rawdata>
            <value><![CDATA[]]></value>
          </rawdata>
          <displaydata>
            <value><![CDATA[]]></value>
          </displaydata>
        </column>
        <column sequence="91" attributecolumnid="2809">
          <rawdata>
            <value><![CDATA[]]></value>
          </rawdata>
          <displaydata>
            <value><![CDATA[]]></value>
          </displaydata>
        </column>
        <column sequence="98" attributecolumnid="2816">
          <rawdata>
            <value><![CDATA[${maxTermofPayment_months}]]></value>
          </rawdata>
          <displaydata>
            <value><![CDATA[${maxTermofPayment_months}]]></value>
          </displaydata>
        </column>
        <column sequence="99" attributecolumnid="2817">
          <rawdata>
            <value><![CDATA[${maxTermofPayment_days}]]></value>
          </rawdata>
          <displaydata>
            <value><![CDATA[${maxTermofPayment_days}]]></value>
          </displaydata>
        </column>
        <column sequence="100" attributecolumnid="2818">
          <rawdata>
            <value><![CDATA[${formatDateDDMMMYYY(
              dateofFacilityLetter
            )}]]></value>
          </rawdata>
          <displaydata>
            <value><![CDATA[${formatDateDDMMMYYY(
              dateofFacilityLetter
            )}]]></value>
          </displaydata>
        </column>
        <column sequence="101" attributecolumnid="2819">
          <rawdata>
            <value><![CDATA[${facilityAvailabilityPeriod_days}]]></value>
          </rawdata>
          <displaydata>
            <value><![CDATA[${facilityAvailabilityPeriod_days}]]></value>
          </displaydata>
        </column>
        <column sequence="102" attributecolumnid="2820">
          <rawdata>
            <value><![CDATA[${facilityAvailabilityPeriod_months}]]></value>
          </rawdata>
          <displaydata>
            <value><![CDATA[${facilityAvailabilityPeriod_months}]]></value>
          </displaydata>
        </column>
        <column sequence="103" attributecolumnid="2821">
          <rawdata>
            <value><![CDATA[${contractForm_Contract1}]]></value>
          </rawdata>
          <displaydata>
            <value><![CDATA[${contractForm_Contract1}]]></value>
          </displaydata>
        </column>
        <column sequence="104" attributecolumnid="2822">
          <rawdata>
            <value><![CDATA[${contractForm_Contract2}]]></value>
          </rawdata>
          <displaydata>
            <value><![CDATA[${contractForm_Contract2}]]></value>
          </displaydata>
        </column>
        <column sequence="105" attributecolumnid="2823">
          <rawdata>
            <value><![CDATA[${contractForm_Contract3}]]></value>
          </rawdata>
          <displaydata>
            <value><![CDATA[${contractForm_Contract3}]]></value>
          </displaydata>
        </column>
        <column sequence="106" attributecolumnid="2824">
          <rawdata>
            <value><![CDATA[${tranche3Limit}]]></value>
          </rawdata>
          <displaydata>
            <value><![CDATA[${tranche3Limit}]]></value>
          </displaydata>
        </column>
	</item>
		
	</data>
	<sheettypeid>0</sheettypeid>
	<enablesmartform>string</enablesmartform>
	<allowDeletedItemsView>string</allowDeletedItemsView>
	<allowAllColumnsInCustomView>string</allowAllColumnsInCustomView>
</isheet>`;

        console.log("xmlData", xmlData);

        const postData8_7 = async () => {
          try {
            const res = await axios.post(`${API_URL}/postbLoan8_7`, xmlData, {
              headers: {
                "Content-Type": "application/xml",
              },
            });

            console.log("Response_data:", res.data.progressivekey);

            const progressiveKey = res.data.progressivekey;
            // start here
            const response = await axios.post(
              `${BACKEND_URL}/getHighQResponse/${progressiveKey}`
            );
            console.log("Response_data_progresskey:", response.data);
            const msg = response.data?.[0]?.columns?.[0]?.message;

            setStatus(msg || "iSheet successfully generated");

            onUploadSuccess();
            setTimeout(() => {
              resetAll();
            }, 2000);
          } catch (error) {
            console.error("Error sending data:", error);
          }
        };
        postData8_7();
      }

      if (product_type === "") {
        console.log("Logged");
        const xmlData = `<?xml version="1.0" encoding="UTF-8"?>
        <isheet recordcount="string">
          <id>0</id>
          <title>string</title>
          <description>string</description>
          <status>string</status>
          <accesstype>string</accesstype>
          <type>string</type>
          <viewlink>string</viewlink>
          <allowsections>string</allowsections>
          <allowlookup>string</allowlookup>
          <displayisheet>string</displayisheet>
          <searchasdefaultview>string</searchasdefaultview>
          <enableversion>string</enableversion>
          <enablesheetalerter>string</enablesheetalerter>
          <alertercondition>string</alertercondition>
          <overrideitemmodifieddate>string</overrideitemmodifieddate>
          <enablebulkinsertupdate>string</enablebulkinsertupdate>
          <fielddescriptions>string</fielddescriptions>
          <enablerowlocking>string</enablerowlocking>
          <setcharlimittruncatemultilinetextenabled>string</setcharlimittruncatemultilinetextenabled>
          <setcharlimittruncatemultilinetextval>string</setcharlimittruncatemultilinetextval>
          <allowchoicelistvaluesforreuse>string</allowchoicelistvaluesforreuse>
          <allowscorelistvaluesforreuse>string</allowscorelistvaluesforreuse>
          <allowIsheetComments>string</allowIsheetComments>
          <shareRecordsLimit>0</shareRecordsLimit>
          <shareRecordsLimitEnabled>0</shareRecordsLimitEnabled>
          <enableIsheetAddRecordFormSharing>string</enableIsheetAddRecordFormSharing>
          <allowViewBaseRendering>string</allowViewBaseRendering>
          <columns>
            <column sequence="string" attributecolumnid="string">
              <columnid>0</columnid>
              <name>test</name>
              <type>0</type>
              <status>0</status>
              <systemgeneratedtype>string</systemgeneratedtype>
              <section>0</section>
              <description>string</description>
              <addtodefaultview>string</addtodefaultview>
              <columnconditionstate>string</columnconditionstate>
              <columnconditions>
                <row>
                  <rowid>0</rowid>
                  <columnid>0</columnid>
                  <operatorid>0</operatorid>
                  <oprand>string</oprand>
                  <logicaltype>string</logicaltype>
                  <sheetfiltervaluetypeid>string</sheetfiltervaluetypeid>
                  <displaytype>string</displaytype>
                  <scoreConditionTypeid>0</scoreConditionTypeid>
                  <sourceColumnId>0</sourceColumnId>
                </row>
              </columnconditions>
              <columnspecificdetail>
                <defaultvalue>string</defaultvalue>
                <columnwidth>string</columnwidth>
                <sheetname>string</sheetname>
                <sitename>string</sitename>
                <mandatory>string</mandatory>
                <allowsearch>string</allowsearch>
                <maxchars>0</maxchars>
                <allowfieldfromanotherisheet>string</allowfieldfromanotherisheet>
                <allowrichhtmltext>string</allowrichhtmltext>
                <numberoflines>0</numberoflines>
                <displaymethod>string</displaymethod>
                <includeotheroption>string</includeotheroption>
                <singleormultileselectioninsearch>string</singleormultileselectioninsearch>
                <choices>
                  <choice>
                    <id>string</id>
                    <label>string</label>
                    <score>string</score>
                    <color>string</color>
                    <imageid>0</imageid>
                  </choice>
                </choices>
                <includeinalertpreferences>string</includeinalertpreferences>
                <min>string</min>
                <max>string</max>
                <decimalplaces>0</decimalplaces>
                <showthousandseparators>string</showthousandseparators>
                <showaspercentage>string</showaspercentage>
                <symbolId>string</symbolId>
                <numberDecimalFormat>DOT_AS_DECIMAL/COMMA_AS_DECIMAL</numberDecimalFormat>
                <symbolPosition>before/after</symbolPosition>
                <formattype>string</formattype>
                <dateformat>string</dateformat>
                <defaultdateandtime>string</defaultdateandtime>
                <sheetlookup>string</sheetlookup>
                <fielddisplay>string</fielddisplay>
                <allowmultipleusers>string</allowmultipleusers>
                <methodtype>string</methodtype>
                <sheetids>string</sheetids>
                <allowuserstorenamelinks>string</allowuserstorenamelinks>
                <sheetid>0</sheetid>
                <columnids>string</columnids>
                <viewid>0</viewid>
                <allowmultiplevalues>string</allowmultiplevalues>
                <restrictdelete>string</restrictdelete>
                <displaycolumnnameprefix>string</displaycolumnnameprefix>
                <linkname>string</linkname>
                <donotcountweekendsonlycountmontofri>string</donotcountweekendsonlycountmontofri>
                <joinconditions>
                  <joincondition>
                    <currentsheetcolumnid>0</currentsheetcolumnid>
                    <targetsheetcolumnid>0</targetsheetcolumnid>
                  </joincondition>
                </joinconditions>
                <formula>string</formula>
                <startvalue>0</startvalue>
                <prefix>string</prefix>
                <postfix>string</postfix>
                <minlength>0</minlength>
                <lookupglossarysheetid>0</lookupglossarysheetid>
                <lookupglossarysheetviewid>0</lookupglossarysheetviewid>
                <width>0</width>
                <otherscorevalue>string</otherscorevalue>
                <importdatafromexternalsource>string</importdatafromexternalsource>
                <analysisengine>string</analysisengine>
                <attachmentcustomfolderid/>
                <singleLineEmailValidation>string</singleLineEmailValidation>
                <readonly>string</readonly>
                <virtualColumn>0</virtualColumn>
                <externalSource>string</externalSource>
                <allowInlineEditing>string</allowInlineEditing>
              </columnspecificdetail>
              <rawdata>
                <value>string</value>
                <choices>
                  <choice>
                    <id>string</id>
                    <label>string</label>
                    <score>string</score>
                    <color>string</color>
                    <imageid>0</imageid>
                  </choice>
                </choices>
                <date>string</date>
                <time>string</time>
                <linkdisplayname>string</linkdisplayname>
                <linkdisplayurl>string</linkdisplayurl>
                <lookups>
                  <lookup>
                    <id>string</id>
                    <email>string</email>
                    <userlookuptype>string</userlookuptype>
                  </lookup>
                </lookups>
                <folders>
                  <folder>
                    <folderid>string</folderid>
                  </folder>
                </folders>
                <documents>
                  <document>
                    <docid>string</docid>
                  </document>
                </documents>
                <fromdate>string</fromdate>
                <todate>string</todate>
                <attachments>
                  <attachment>
                    <file>string</file>
                    <name>string</name>
                    <order>string</order>
                    <id>0</id>
                    <extension>string</extension>
                    <parentfolderid>0</parentfolderid>
                    <filehttplink>string</filehttplink>
                    <folderpath>string</folderpath>
                    <folderhttplink>string</folderhttplink>
                    <filesize>0</filesize>
                    <redactionstatus>true</redactionstatus>
                    <siteid>0</siteid>
                    <displayname>string</displayname>
                  </attachment>
                </attachments>
                <isheetitems>
                  <isheetitem>
                    <recordid>string</recordid>
                    <linkname>string</linkname>
                    <apilink>string</apilink>
                    <httplink>string</httplink>
                  </isheetitem>
                </isheetitems>
                <daydifference>string</daydifference>
              </rawdata>
              <colViewPosition>0</colViewPosition>
              <columntype>string</columntype>
              <createdDate>2025-04-08T07:16:21.504Z</createdDate>
              <modifiedDate>2025-04-08T07:16:21.504Z</modifiedDate>
              <injectReferenceColumn>0</injectReferenceColumn>
              <parentColumnID>0</parentColumnID>
              <reusecolumnidfromisheet>0</reusecolumnidfromisheet>
              <choicelistid>0</choicelistid>
              <editpermission>0</editpermission>
              <templatesheetcolumnid>0</templatesheetcolumnid>
              <uploadpermission>0</uploadpermission>
              <deletepermission>0</deletepermission>
              <sourceSheetID>0</sourceSheetID>
            </column>
          </columns>
          <metadata>
            <viewName>string</viewName>
            <viewId>0</viewId>
            <sheetName>string</sheetName>
            <siteId>0</siteId>
            <siteName>string</siteName>
            <sheetId>0</sheetId>
          </metadata>
          <head>
              <headcolumn sequence="1" columntypealias="SHEET_COLUMN_TYPE_LOOKUP" columntypeid="6" columnid="741">
                <columnvalue><![CDATA[Created by]]></columnvalue>
              </headcolumn>
              <headcolumn sequence="2" columntypealias="SHEET_COLUMN_TYPE_DATE_AND_TIME" columntypeid="5" columnid="742">
                <columnvalue><![CDATA[Created date]]></columnvalue>
              </headcolumn>
              <headcolumn sequence="3" columntypealias="SHEET_COLUMN_TYPE_LOOKUP" columntypeid="6" columnid="743">
                <columnvalue><![CDATA[Modified by]]></columnvalue>
              </headcolumn>
              <headcolumn sequence="4" columntypealias="SHEET_COLUMN_TYPE_DATE_AND_TIME" columntypeid="5" columnid="744">
                <columnvalue><![CDATA[Modified date]]></columnvalue>
              </headcolumn>
              <headcolumn sequence="5" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="745">
                <columnvalue><![CDATA[Riverchain ID]]></columnvalue>
              </headcolumn>
              <headcolumn sequence="6" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="746">
                <columnvalue><![CDATA[Borrower Name English]]></columnvalue>
              </headcolumn>
              <headcolumn sequence="7" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="747">
                <columnvalue><![CDATA[Borrower Name Chinese]]></columnvalue>
              </headcolumn>
              <headcolumn sequence="8" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="748">
                <columnvalue><![CDATA[Borrower BR No.]]></columnvalue>
              </headcolumn>
              <headcolumn sequence="9" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="749">
                <columnvalue><![CDATA[Borrower Contact Details - Person]]></columnvalue>
              </headcolumn>
              <headcolumn sequence="10" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="750">
                <columnvalue><![CDATA[Borrower Contact Details - Phone]]></columnvalue>
              </headcolumn>
              <headcolumn sequence="11" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="751">
                <columnvalue><![CDATA[Borrower Contact Details - Email]]></columnvalue>
              </headcolumn>
              <headcolumn sequence="12" columntypealias="SHEET_COLUMN_TYPE_MULTIPLE_LINE_TEXT" columntypeid="2" columnid="752">
                <columnvalue><![CDATA[Borrower Address]]></columnvalue>
              </headcolumn>
              <headcolumn sequence="13" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="753">
                <columnvalue><![CDATA[Borrower Place of Incorporation]]></columnvalue>
              </headcolumn>
              <headcolumn sequence="14" columntypealias="SHEET_COLUMN_TYPE_CHOICE" columntypeid="3" columnid="754">
                <columnvalue><![CDATA[Lender Company Name]]></columnvalue>
              </headcolumn>
              <headcolumn sequence="15" columntypealias="SHEET_COLUMN_TYPE_CHOICE" columntypeid="3" columnid="755">
                <columnvalue><![CDATA[Loan Type (2.1)]]></columnvalue>
              </headcolumn>
              <headcolumn sequence="16" columntypealias="SHEET_COLUMN_TYPE_CHOICE" columntypeid="3" columnid="756">
                <columnvalue><![CDATA[Loan Type 2.2]]></columnvalue>
              </headcolumn>
              <headcolumn sequence="17" columntypealias="SHEET_COLUMN_TYPE_NUMBER" columntypeid="4" columnid="757">
                <columnvalue><![CDATA[Facility Limit (2.1)]]></columnvalue>
              </headcolumn>
              <headcolumn sequence="18" columntypealias="SHEET_COLUMN_TYPE_NUMBER" columntypeid="4" columnid="758">
                <columnvalue><![CDATA[Facility Limit (2.2)]]></columnvalue>
              </headcolumn>
              <headcolumn sequence="19" columntypealias="SHEET_COLUMN_TYPE_NUMBER" columntypeid="4" columnid="759">
                <columnvalue><![CDATA[Final Maturity Period]]></columnvalue>
              </headcolumn>
              <headcolumn sequence="20" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="760">
                <columnvalue><![CDATA[Drawdown Availability Period]]></columnvalue>
              </headcolumn>
              <headcolumn sequence="21" columntypealias="SHEET_COLUMN_TYPE_NUMBER" columntypeid="4" columnid="761">
                <columnvalue><![CDATA[Interest Rates]]></columnvalue>
              </headcolumn>
              <headcolumn sequence="22" columntypealias="SHEET_COLUMN_TYPE_NUMBER" columntypeid="4" columnid="762">
                <columnvalue><![CDATA[HIBOR Interest Rates]]></columnvalue>
              </headcolumn>
              <headcolumn sequence="23" columntypealias="SHEET_COLUMN_TYPE_CHOICE" columntypeid="3" columnid="763">
                <columnvalue><![CDATA[Repayment Type (2.1)]]></columnvalue>
              </headcolumn>
              <headcolumn sequence="24" columntypealias="SHEET_COLUMN_TYPE_CHOICE" columntypeid="3" columnid="764">
                <columnvalue><![CDATA[Repayment Type 2]]></columnvalue>
              </headcolumn>
              <headcolumn sequence="25" columntypealias="SHEET_COLUMN_TYPE_NUMBER" columntypeid="4" columnid="765">
                <columnvalue><![CDATA[Invoice amount]]></columnvalue>
              </headcolumn>
              <headcolumn sequence="26" columntypealias="SHEET_COLUMN_TYPE_NUMBER" columntypeid="4" columnid="766">
                <columnvalue><![CDATA[Invoice Financing %]]></columnvalue>
              </headcolumn>
              <headcolumn sequence="27" columntypealias="SHEET_COLUMN_TYPE_MULTIPLE_LINE_TEXT" columntypeid="2" columnid="767">
                <columnvalue><![CDATA[Borrower's Contractor]]></columnvalue>
              </headcolumn>
              <headcolumn sequence="28" columntypealias="SHEET_COLUMN_TYPE_NUMBER" columntypeid="4" columnid="768">
                <columnvalue><![CDATA[Admin Fee]]></columnvalue>
              </headcolumn>
              <headcolumn sequence="29" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="769">
                <columnvalue><![CDATA[Sub Contract No. (1)]]></columnvalue>
              </headcolumn>
              <headcolumn sequence="30" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="770">
                <columnvalue><![CDATA[Sub Contract Project Details (1)]]></columnvalue>
              </headcolumn>
              <headcolumn sequence="31" columntypealias="SHEET_COLUMN_TYPE_DATE_AND_TIME" columntypeid="5" columnid="771">
                <columnvalue><![CDATA[sub contract date (1)]]></columnvalue>
              </headcolumn>
              <headcolumn sequence="32" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="772">
                <columnvalue><![CDATA[Sub Contract Invoice No (1)]]></columnvalue>
              </headcolumn>
              <headcolumn sequence="33" columntypealias="SHEET_COLUMN_TYPE_DATE_AND_TIME" columntypeid="5" columnid="773">
                <columnvalue><![CDATA[Sub contract Invoice date]]></columnvalue>
              </headcolumn>
              <headcolumn sequence="34" columntypealias="SHEET_COLUMN_TYPE_NUMBER" columntypeid="4" columnid="774">
                <columnvalue><![CDATA[Sub contract invoice amount]]></columnvalue>
              </headcolumn>
              <headcolumn sequence="35" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="859">
                <columnvalue><![CDATA[Borrower's Bank Name]]></columnvalue>
              </headcolumn>
              <headcolumn sequence="36" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="860">
                <columnvalue><![CDATA[Borrower's Bank Account No.]]></columnvalue>
              </headcolumn>
              <headcolumn sequence="37" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="861">
                <columnvalue><![CDATA[Borrower's Bank Account Name]]></columnvalue>
              </headcolumn>
              <headcolumn sequence="39" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="863">
                <columnvalue><![CDATA[Borrower's Bank Swift Code]]></columnvalue>
              </headcolumn>
              <headcolumn sequence="40" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="864">
                <columnvalue><![CDATA[Borrower's Emoloyer]]></columnvalue>
              </headcolumn>
              <headcolumn sequence="41" columntypealias="SHEET_COLUMN_TYPE_CHOICE" columntypeid="3" columnid="865">
                <columnvalue><![CDATA[Contract Type]]></columnvalue>
              </headcolumn>
              <headcolumn sequence="42" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="866">
                <columnvalue><![CDATA[Payment Application No.]]></columnvalue>
              </headcolumn>
              <headcolumn sequence="43" columntypealias="SHEET_COLUMN_TYPE_NUMBER" columntypeid="4" columnid="867">
                <columnvalue><![CDATA[Payment Application Amount]]></columnvalue>
              </headcolumn>
              <headcolumn sequence="44" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="868">
                <columnvalue><![CDATA[Collection Agent signor name]]></columnvalue>
              </headcolumn>
              <headcolumn sequence="45" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="869">
                <columnvalue><![CDATA[Collection Agent signor title]]></columnvalue>
              </headcolumn>
              <headcolumn sequence="46" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="870">
                <columnvalue><![CDATA[Lender Company signor name]]></columnvalue>
              </headcolumn>
              <headcolumn sequence="47" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="871">
                <columnvalue><![CDATA[Lender company signor title]]></columnvalue>
              </headcolumn>
              <headcolumn sequence="48" columntypealias="SHEET_COLUMN_TYPE_CHOICE" columntypeid="3" columnid="872">
                <columnvalue><![CDATA[Collect Agent company name]]></columnvalue>
              </headcolumn>
               <headcolumn sequence="49" columntypealias="SHEET_COLUMN_TYPE_DATE_AND_TIME" columntypeid="5" columnid="873">
                <columnvalue><![CDATA[Payment Application date]]></columnvalue>
              </headcolumn>
              <headcolumn sequence="50" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="874">
                <columnvalue><![CDATA[Payment Certificate Number]]></columnvalue>
              </headcolumn>
              <headcolumn sequence="51" columntypealias="SHEET_COLUMN_TYPE_DATE_AND_TIME" columntypeid="5" columnid="875">
                <columnvalue><![CDATA[Payment Certificate Date]]></columnvalue>
              </headcolumn>
              <headcolumn sequence="52" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="876">
                <columnvalue><![CDATA[Payment Certificate issued by]]></columnvalue>
              </headcolumn>
              <headcolumn sequence="53" columntypealias="SHEET_COLUMN_TYPE_NUMBER" columntypeid="4" columnid="877">
                <columnvalue><![CDATA[Payment certificate amount]]></columnvalue>
              </headcolumn>
              <headcolumn sequence="54" columntypealias="SHEET_COLUMN_TYPE_NUMBER" columntypeid="4" columnid="878">
                <columnvalue><![CDATA[Payment Certificate amount (Cumulative)]]></columnvalue>
              </headcolumn>
              <headcolumn sequence="55" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="1008">
                <columnvalue><![CDATA[Extension Approved Notice Period]]></columnvalue>
              </headcolumn>
              <headcolumn sequence="56" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="1009">
                <columnvalue><![CDATA[Extension Request Notice Period]]></columnvalue>
              </headcolumn>
              <headcolumn sequence="57" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="1010">
                <columnvalue><![CDATA[Maximum no. of extensions]]></columnvalue>
              </headcolumn>
              <headcolumn sequence="58" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="1011">
                <columnvalue><![CDATA[Number of extensions]]></columnvalue>
              </headcolumn>
              <headcolumn sequence="59" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="1012">
                <columnvalue><![CDATA[Supplier invoice issue no of days]]></columnvalue>
              </headcolumn>
              <headcolumn sequence="60" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="1013">
                <columnvalue><![CDATA[Term/Revolving Loan Purpose]]></columnvalue>
              </headcolumn>
              <headcolumn sequence="61" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="1014">
                <columnvalue><![CDATA[Term/Revolving Loan Drawdown Availability]]></columnvalue>
              </headcolumn>
              <headcolumn sequence="62" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="1015">
                <columnvalue><![CDATA[Name of Security Provider]]></columnvalue>
              </headcolumn>
              <headcolumn sequence="63" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="1017">
                <columnvalue><![CDATA[Voluntary Prepayment Notice Period]]></columnvalue>
              </headcolumn>
              <headcolumn sequence="64" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="1018">
                <columnvalue><![CDATA[Conditions Subsequent Documents Delivery]]></columnvalue>
              </headcolumn>
              <headcolumn sequence="65" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="1106">
                <columnvalue><![CDATA[Sub Contract No. (2)]]></columnvalue>
              </headcolumn>
              <headcolumn sequence="66" columntypealias="SHEET_COLUMN_TYPE_DATE_AND_TIME" columntypeid="5" columnid="1107">
                <columnvalue><![CDATA[Sub Contract Date (2)]]></columnvalue>
              </headcolumn>
              <headcolumn sequence="67" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="1108">
                <columnvalue><![CDATA[Sub Contract Project Details (2)]]></columnvalue>
              </headcolumn>
              <headcolumn sequence="68" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="1109">
                <columnvalue><![CDATA[Borrower's Contractor (2)]]></columnvalue>
              </headcolumn>
              <headcolumn sequence="70" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="1278">
                <columnvalue><![CDATA[Borrower's Bank Code]]></columnvalue>
              </headcolumn>
              <headcolumn sequence="71" columntypealias="SHEET_COLUMN_TYPE_CHOICE" columntypeid="3" columnid="1547">
                <columnvalue><![CDATA[Repayment Currency]]></columnvalue>
              </headcolumn>
              <headcolumn sequence="72" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="1580">
                <columnvalue><![CDATA[Tranche 1 Drawdown days]]></columnvalue>
              </headcolumn>
              <headcolumn sequence="73" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="1581">
                <columnvalue><![CDATA[Tranche 2 Drawdown days]]></columnvalue>
              </headcolumn>
              <headcolumn sequence="74" columntypealias="SHEET_COLUMN_TYPE_NUMBER" columntypeid="4" columnid="1582">
                <columnvalue><![CDATA[Default Interest Rate]]></columnvalue>
              </headcolumn>
              <headcolumn sequence="75" columntypealias="SHEET_COLUMN_TYPE_NUMBER" columntypeid="4" columnid="1597">
                <columnvalue><![CDATA[Term Loan Tranche 1]]></columnvalue>
              </headcolumn>
              <headcolumn sequence="76" columntypealias="SHEET_COLUMN_TYPE_NUMBER" columntypeid="4" columnid="1598">
                <columnvalue><![CDATA[Term Loan Tranche 2]]></columnvalue>
              </headcolumn>
              <headcolumn sequence="77" columntypealias="SHEET_COLUMN_TYPE_NUMBER" columntypeid="4" columnid="1619">
                <columnvalue><![CDATA[Revenue Based Repaymentment Invoice Amount Percentage]]></columnvalue>
              </headcolumn>
              <headcolumn sequence="78" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="1620">
                <columnvalue><![CDATA[Sub Contract No. (3)]]></columnvalue>
              </headcolumn>
              <headcolumn sequence="79" columntypealias="SHEET_COLUMN_TYPE_DATE_AND_TIME" columntypeid="5" columnid="1621">
                <columnvalue><![CDATA[Sub Contract Date (3)]]></columnvalue>
              </headcolumn>
              <headcolumn sequence="80" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="1622">
                <columnvalue><![CDATA[Sub Contract Project Details (3)]]></columnvalue>
              </headcolumn>
              <headcolumn sequence="81" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="1623">
                <columnvalue><![CDATA[Borrower's Contractor (3)]]></columnvalue>
              </headcolumn>
              <headcolumn sequence="82" columntypealias="SHEET_COLUMN_TYPE_CHOICE" columntypeid="3" columnid="1624">
                <columnvalue><![CDATA[Contract Type (2)]]></columnvalue>
              </headcolumn>
              <headcolumn sequence="83" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="1625">
                <columnvalue><![CDATA[Borrower's Emoloyer (2)]]></columnvalue>
              </headcolumn>
              <headcolumn sequence="84" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="1626">
                <columnvalue><![CDATA[Borrower's Emoloyer (3)]]></columnvalue>
              </headcolumn>
              <headcolumn sequence="85" columntypealias="SHEET_COLUMN_TYPE_CHOICE" columntypeid="3" columnid="1627">
                <columnvalue><![CDATA[Contract Type (3)]]></columnvalue>
              </headcolumn>
              <headcolumn sequence="86" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="1628">
                <columnvalue><![CDATA[Sub Contract Invoice No (2)]]></columnvalue>
              </headcolumn>
              <headcolumn sequence="87" columntypealias="SHEET_COLUMN_TYPE_DATE_AND_TIME" columntypeid="5" columnid="1629">
                <columnvalue><![CDATA[Sub contract Invoice date (2)]]></columnvalue>
              </headcolumn>
              <headcolumn sequence="88" columntypealias="SHEET_COLUMN_TYPE_NUMBER" columntypeid="4" columnid="1630">
                <columnvalue><![CDATA[Sub contract invoice amount (2)]]></columnvalue>
              </headcolumn>
              <headcolumn sequence="89" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="1631">
                <columnvalue><![CDATA[Sub Contract Invoice No (3)]]></columnvalue>
              </headcolumn>
              <headcolumn sequence="90" columntypealias="SHEET_COLUMN_TYPE_DATE_AND_TIME" columntypeid="5" columnid="1632">
                <columnvalue><![CDATA[Sub contract Invoice date (3)]]></columnvalue>
              </headcolumn>
              <headcolumn sequence="91" columntypealias="SHEET_COLUMN_TYPE_NUMBER" columntypeid="4" columnid="1633">
                <columnvalue><![CDATA[Sub contract invoice amount (3)]]></columnvalue>
              </headcolumn>
              <headcolumn sequence="92" columntypealias="SHEET_COLUMN_TYPE_CHOICE" columntypeid="3" columnid="1634">
                <columnvalue><![CDATA[Sole/Multiple Director]]></columnvalue>
              </headcolumn>
              <headcolumn sequence="93" columntypealias="SHEET_COLUMN_TYPE_NUMBER" columntypeid="4" columnid="1635">
                <columnvalue><![CDATA[Payment certificate amount (2)]]></columnvalue>
              </headcolumn>
              <headcolumn sequence="94" columntypealias="SHEET_COLUMN_TYPE_NUMBER" columntypeid="4" columnid="1636">
                <columnvalue><![CDATA[Payment certificate amount (3)]]></columnvalue>
              </headcolumn>
            </head>
            <data>
            <item externalid="" itemsequence="200" itemid="201">
                <column sequence="5" attributecolumnid="745">
                  <rawdata>
                    <value><![CDATA[${newriverchainID}]]></value>
                  </rawdata>
                  <displaydata>
                    <value><![CDATA[${newriverchainID}]]></value>
                  </displaydata>
                </column>
            <column sequence="6" attributecolumnid="746">
                  <rawdata>
                    <value><![CDATA[${borrowerNameEng}]]></value>
                  </rawdata>
                  <displaydata>
                    <value><![CDATA[${borrowerNameEng}]]></value>
                  </displaydata>
                </column>
            <column sequence="7" attributecolumnid="747">
                  <rawdata>
                    <value><![CDATA[${borrowerNameChinese}]]></value>
                  </rawdata>
                  <displaydata>
                    <value><![CDATA[${borrowerNameChinese}]]></value>
                  </displaydata>
                </column>
            <column sequence="8" attributecolumnid="748">
                  <rawdata>
                    <value><![CDATA[${businessRegistrationNumber}]]></value>
                  </rawdata>
                  <displaydata>
                    <value><![CDATA[${businessRegistrationNumber}]]></value>
                  </displaydata>
                </column>
            <column sequence="9" attributecolumnid="749">
                  <rawdata>
                    <value><![CDATA[${contactname}]]></value>
                  </rawdata>
                  <displaydata>
                    <value><![CDATA[${contactname}]]></value>
                  </displaydata>
                </column>
            <column sequence="10" attributecolumnid="750">
                  <rawdata>
                    <value><![CDATA[${contactphonenumber}]]></value>
                  </rawdata>
                  <displaydata>
                    <value><![CDATA[${contactphonenumber}]]></value>
                  </displaydata>
                </column>
            <column sequence="11" attributecolumnid="751">
                  <rawdata>
                    <value><![CDATA[${contactemailaddress}]]></value>
                  </rawdata>
                  <displaydata>
                    <value><![CDATA[${contactemailaddress}]]></value>
                  </displaydata>
                </column>
            <column sequence="12" attributecolumnid="752">
                  <rawdata>
                    <value><![CDATA[${registeredAddress}]]></value>
                  </rawdata>
                  <displaydata>
                    <value><![CDATA[${registeredAddress}]]></value>
                  </displaydata>
                </column>
            <column sequence="13" attributecolumnid="753">
                  <rawdata>
                    <value><![CDATA[${placeofincorporation}]]></value>
                  </rawdata>
                  <displaydata>
                    <value><![CDATA[${placeofincorporation}]]></value>
                  </displaydata>
                </column>
            <column sequence="14" attributecolumnid="754">
                  <rawdata>
                <choices>
                  <choice>
                      <id>${newlenderNo}</id>
                  </choice>
                </choices>
                    </rawdata>
                </column>
            <column sequence="15" attributecolumnid="755">
                  <rawdata>
                <choices>
                  <choice>
                      <id>${newProNo}</id>
                  </choice>
                </choices>
                    </rawdata>
                </column>
            <column sequence="16" attributecolumnid="756">
                  <rawdata>
                <choices>
                  <choice>
                      <id></id>
                  </choice>
                </choices>
                    </rawdata>
                </column>
                <column sequence="17" attributecolumnid="757">
                  <rawdata>
                    <value><![CDATA[${newfacilityLimit}]]></value>
                  </rawdata>
                  <displaydata>
                    <value><![CDATA[${newfacilityLimit}]]></value>
                  </displaydata>
                </column>
                <column sequence="18" attributecolumnid="758">
                  <rawdata>
                    <value><![CDATA[]]></value>
                  </rawdata>
                  <displaydata>
                    <value><![CDATA[]]></value>
                  </displaydata>
                </column>
                <column sequence="19" attributecolumnid="759">
                  <rawdata>
                    <value><![CDATA[${NewmaxTerm}]]></value>
                  </rawdata>
                  <displaydata>
                    <value><![CDATA[${NewmaxTerm}]]></value>
                  </displaydata>
                </column>
                <column sequence="20" attributecolumnid="760">
                  <rawdata>
                    <value><![CDATA[${drawDownAvailability}]]></value>
                  </rawdata>
                  <displaydata>
                    <value><![CDATA[${drawDownAvailability}]]></value>
                  </displaydata>
                </column>
                <column sequence="21" attributecolumnid="761">
                  <rawdata>
                    <value><![CDATA[${newinterestRate}]]></value>
                  </rawdata>
                  <displaydata>
                    <value><![CDATA[${newinterestRate}]]></value>
                  </displaydata>
                </column>
                <column sequence="22" attributecolumnid="762">
                  <rawdata>
                    <value><![CDATA[]]></value>
                  </rawdata>
                  <displaydata>
                    <value><![CDATA[]]></value>
                  </displaydata>
                </column>
                <column sequence="23" attributecolumnid="763">
                  <rawdata>
                <choices>
                  <choice>
                      <id>${newrepaymentOne}</id>
                  </choice>
                </choices>
                    </rawdata>
                </column>
                <column sequence="24" attributecolumnid="764">
                  <rawdata>
                <choices>
                  <choice>
                      <id></id>
                  </choice>
                </choices>
                    </rawdata>
                </column>
                <column sequence="25" attributecolumnid="765">
                  <rawdata>
                    <value><![CDATA[${newinvoiceAmountFinal}]]></value>
                  </rawdata>
                  <displaydata>
                    <value><![CDATA[${newinvoiceAmountFinal}]]></value>
                  </displaydata>
                </column>
                <column sequence="26" attributecolumnid="766">
                  <rawdata>
                    <value><![CDATA[${newInvoiceFinancing}]]></value>
                  </rawdata>
                  <displaydata>
                    <value><![CDATA[${newInvoiceFinancing}]]></value>
                  </displaydata>
                </column>
                <column sequence="27" attributecolumnid="767">
                  <rawdata>
                    <value><![CDATA[${newborrowerContractor}]]></value>
                  </rawdata>
                  <displaydata>
                    <value><![CDATA[${newborrowerContractor}]]></value>
                  </displaydata>
                </column>
                <column sequence="28" attributecolumnid="768">
                  <rawdata>
                    <value><![CDATA[${newadminFee}]]></value>
                  </rawdata>
                  <displaydata>
                    <value><![CDATA[${newadminFee}]]></value>
                  </displaydata>
                </column>
                <column sequence="29" attributecolumnid="769">
                  <rawdata>
                    <value><![CDATA[${subContractorNo}]]></value>
                  </rawdata>
                  <displaydata>
                    <value><![CDATA[${subContractorNo}]]></value>
                  </displaydata>
                </column>
                <column sequence="30" attributecolumnid="770">
                  <rawdata>
                    <value><![CDATA[${projectDetails}]]></value>
                  </rawdata>
                  <displaydata>
                    <value><![CDATA[${projectDetails}]]></value>
                  </displaydata>
                </column>
                <column sequence="31" attributecolumnid="771">
                  <rawdata>
                    <date><![CDATA[${newStartDate}]]></date>
                  </rawdata>
                  <displaydata>
                    <value><![CDATA[${newStartDate}]]></value>
                  </displaydata>
                </column>
                <column sequence="32" attributecolumnid="772">
                  <rawdata>
                    <value><![CDATA[${newInvoiceNo}]]></value>
                  </rawdata>
                  <displaydata>
                    <value><![CDATA[${newInvoiceNo}]]></value>
                  </displaydata>
                </column>
                <column sequence="33" attributecolumnid="773">
                  <rawdata>
                    <date><![CDATA[${newInvoiceDate}]]></date>
                  </rawdata>
                  <displaydata>
                    <value><![CDATA[${newInvoiceDate}]]></value>
                  </displaydata>
                </column>
                <column sequence="34" attributecolumnid="774">
                  <rawdata>
                    <value><![CDATA[${newinvoiceAmountFinal}]]></value>
                  </rawdata>
                  <displaydata>
                    <value><![CDATA[${newinvoiceAmountFinal}]]></value>
                  </displaydata>
                </column>
                <column sequence="35" attributecolumnid="859">
                  <rawdata>
                    <value><![CDATA[${bankName}]]></value>
                  </rawdata>
                  <displaydata>
                    <value><![CDATA[${bankName}]]></value>
                  </displaydata>
                </column>
                <column sequence="36" attributecolumnid="860">
                  <rawdata>
                    <value><![CDATA[${bankAccNo}]]></value>
                  </rawdata>
                  <displaydata>
                    <value><![CDATA[${bankAccNo}]]></value>
                  </displaydata>
                </column>
                <column sequence="37" attributecolumnid="861">
                  <rawdata>
                    <value><![CDATA[${benifiserName}]]></value>
                  </rawdata>
                  <displaydata>
                    <value><![CDATA[${benifiserName}]]></value>
                  </displaydata>
                </column>
                <column sequence="38" attributecolumnid="1278">
                  <rawdata>
                    <value><![CDATA[${bankCode}]]></value>
                  </rawdata>
                  <displaydata>
                    <value><![CDATA[${bankCode}]]></value>
                  </displaydata>
                </column>
                <column sequence="39" attributecolumnid="863">
                  <rawdata>
                    <value><![CDATA[${swift}]]></value>
                  </rawdata>
                  <displaydata>
                    <value><![CDATA[${swift}]]></value>
                  </displaydata>
                </column>
                <column sequence="40" attributecolumnid="864">
                  <rawdata>
                    <value><![CDATA[${employer}]]></value>
                  </rawdata>
                  <displaydata>
                    <value><![CDATA[${employer}]]></value>
                  </displaydata>
                </column>
                <column sequence="41" attributecolumnid="865">
                  <rawdata>
                <choices>
                  <choice>
                      <id>${newcontractType}</id>
                  </choice>
                </choices>
                    </rawdata>
                </column>
                <column sequence="42" attributecolumnid="866">
                  <rawdata>
                    <value><![CDATA[${newInvoiceNo}]]></value>
                  </rawdata>
                  <displaydata>
                    <value><![CDATA[${newInvoiceNo}]]></value>
                  </displaydata>
                </column>
                <column sequence="43" attributecolumnid="867">
                  <rawdata>
                    <value><![CDATA[${newinvoiceAmountFinal}]]></value>
                  </rawdata>
                  <displaydata>
                    <value><![CDATA[${newinvoiceAmountFinal}]]></value>
                  </displaydata>
                </column>
                <column sequence="49" attributecolumnid="873">
                  <rawdata>
                    <date><![CDATA[${newInvoiceDate}]]></date>
                  </rawdata>
                  <displaydata>
                    <value><![CDATA[${newInvoiceDate}]]></value>
                  </displaydata>
                </column>
                <column sequence="53" attributecolumnid="877">
                  <rawdata>
                    <value><![CDATA[${newpaymentCertvalue}]]></value>
                  </rawdata>
                  <displaydata>
                    <value><![CDATA[${newpaymentCertvalue}]]></value>
                  </displaydata>
                </column>
                <column sequence="54" attributecolumnid="878">
                  <rawdata>
                    <value><![CDATA[${newcertiCumValue}]]></value>
                  </rawdata>
                  <displaydata>
                    <value><![CDATA[${newcertiCumValue}]]></value>
                  </displaydata>
                </column>
                <column sequence="65" attributecolumnid="1106">
                  <rawdata>
                    <value><![CDATA[${newsubContractNo2}]]></value>
                  </rawdata>
                  <displaydata>
                    <value><![CDATA[${newsubContractNo2}]]></value>
                  </displaydata>
                </column>
                <column sequence="66" attributecolumnid="1107">
                  <rawdata>
                    <date><![CDATA[${newSubConStartDate}]]></date>
                  </rawdata>
                  <displaydata>
                    <value><![CDATA[${newSubConStartDate}]]></value>
                  </displaydata>
                </column>
                <column sequence="67" attributecolumnid="1108">
                  <rawdata>
                    <value><![CDATA[${newsubContractorprojectDetails}]]></value>
                  </rawdata>
                  <displaydata>
                    <value><![CDATA[${newsubContractorprojectDetails}]]></value>
                  </displaydata>
                </column>
                <column sequence="68" attributecolumnid="1109">
                  <rawdata>
                    <value><![CDATA[${newBororwersContractor2}]]></value>
                  </rawdata>
                  <displaydata>
                    <value><![CDATA[${newBororwersContractor2}]]></value>
                  </displaydata>
                </column>
                <column sequence="78" attributecolumnid="1620">
                  <rawdata>
                    <value><![CDATA[${newsubContractNo3}]]></value>
                  </rawdata>
                  <displaydata>
                    <value><![CDATA[${newsubContractNo3}]]></value>
                  </displaydata>
                </column>
                <column sequence="79" attributecolumnid="1621">
                  <rawdata>
                    <date><![CDATA[${newSubConStartDate3}]]></date>
                  </rawdata>
                  <displaydata>
                    <value><![CDATA[${newSubConStartDate3}]]></value>
                  </displaydata>
                </column>
                <column sequence="80" attributecolumnid="1622">
                  <rawdata>
                    <value><![CDATA[${newsubContractorprojectDetails3}]]></value>
                  </rawdata>
                  <displaydata>
                    <value><![CDATA[${newsubContractorprojectDetails3}]]></value>
                  </displaydata>
                </column>
        
                <column sequence="81" attributecolumnid="1623">
                  <rawdata>
                    <value><![CDATA[${newBororwersContractor3}]]></value>
                  </rawdata>
                  <displaydata>
                    <value><![CDATA[${newBororwersContractor3}]]></value>
                  </displaydata>
                </column>
        
                <column sequence="82" attributecolumnid="1624">
                  <rawdata>
                <choices>
                  <choice>
                      <id>${contractType2 ?? ""}</id>
                  </choice>
                </choices>
                    </rawdata>
                </column>
        
                <column sequence="83" attributecolumnid="1625">
                  <rawdata>
                    <value><![CDATA[${newemp2}]]></value>
                  </rawdata>
                  <displaydata>
                    <value><![CDATA[${newemp2}]]></value>
                  </displaydata>
                </column>
        
                <column sequence="84" attributecolumnid="1626">
                  <rawdata>
                    <value><![CDATA[${newemp3}]]></value>
                  </rawdata>
                  <displaydata>
                    <value><![CDATA[${newemp3}]]></value>
                  </displaydata>
                </column>
        
                <column sequence="85" attributecolumnid="1627">
                  <rawdata>
                <choices>
                  <choice>
                      <id>${contractType3 ?? ""}</id>
                  </choice>
                </choices>
                    </rawdata>
                </column>
        
                <column sequence="84" attributecolumnid="1626">
                  <rawdata>
                    <value><![CDATA[${newemp3}]]></value>
                  </rawdata>
                  <displaydata>
                    <value><![CDATA[${newemp3}]]></value>
                  </displaydata>
                </column>
        
                <column sequence="86" attributecolumnid="1628">
                  <rawdata>
                    <value><![CDATA[${newInvoiceNo2}]]></value>
                  </rawdata>
                  <displaydata>
                    <value><![CDATA[${newInvoiceNo2}]]></value>
                  </displaydata>
                </column>
        
                 <column sequence="87" attributecolumnid="1629">
                  <rawdata>
                    <date><![CDATA[${newInvoiceDate2}]]></date>
                  </rawdata>
                  <displaydata>
                    <value><![CDATA[${newInvoiceDate2}]]></value>
                  </displaydata>
                </column>
        
                <column sequence="88" attributecolumnid="1630">
                  <rawdata>
                    <value><![CDATA[${
                      subContractInvoiceAmount2 ?? ""
                    }]]></value>
                  </rawdata>
                  <displaydata>
                    <value><![CDATA[${
                      subContractInvoiceAmount2 ?? ""
                    }]]></value>
                  </displaydata>
                </column>
        
                <column sequence="89" attributecolumnid="1631">
                  <rawdata>
                    <value><![CDATA[${newInvoiceNo3}]]></value>
                  </rawdata>
                  <displaydata>
                    <value><![CDATA[${newInvoiceNo3}]]></value>
                  </displaydata>
                </column>
        
                <column sequence="90" attributecolumnid="1632">
                  <rawdata>
                    <date><![CDATA[${newInvoiceDate3}]]></date>
                  </rawdata>
                  <displaydata>
                    <value><![CDATA[${newInvoiceDate3}]]></value>
                  </displaydata>
                </column>
        
                <column sequence="91" attributecolumnid="1633">
                  <rawdata>
                    <value><![CDATA[${
                      subContractInvoiceAmount3 ?? ""
                    }]]></value>
                  </rawdata>
                  <displaydata>
                    <value><![CDATA[${
                      subContractInvoiceAmount3 ?? ""
                    }]]></value>
                  </displaydata>
                </column>
        
              </item>
          </data>
          <sheettypeid>0</sheettypeid>
          <enablesmartform>string</enablesmartform>
          <allowDeletedItemsView>string</allowDeletedItemsView>
          <allowAllColumnsInCustomView>string</allowAllColumnsInCustomView>
        </isheet>`;

        const postData = async () => {
          try {
            const res = await axios.post(`${API_URL}/postb`, xmlData, {
              headers: {
                "Content-Type": "application/xml",
              },
            });

            const progressiveKey = res.data.progressivekey;
            // start here
            const response = await axios.post(
              `${BACKEND_URL}/getHighQResponse/${progressiveKey}`
            );
            console.log("Response_data_progresskey:", response.data);
            const msg = response.data?.[0]?.columns?.[0]?.message;

            setStatus(msg || "iSheet successfully generated");

            onUploadSuccess(); // if you need to refresh list, etc.
            setTimeout(() => {
              resetAll();
            }, 2000);
          } catch (error) {
            console.error("Error sending data:", error);
          } finally {
            setLoading(false);
            setFinalUpload(false); // 🔹 important: stop re-triggering this effect
          }
        };

        postData();
      }
    }
  }, [finalUpload]);

  const handleFile1Change = (e) => {
    const selectedFile = e.target.files[0];
    console.log("selectedFile:", selectedFile);
    if (selectedFile) {
      setFile(selectedFile);
      setStatusCC(null);
    }
  };

  const isRemovingRef = useRef(false);
  const isRemovingRef2 = useRef(false);

  const removeFile = () => {
    isRemovingRef.current = true;
    setFile(null);
    setStatusCC(null);
    if (fileInputRef.current) {
      fileInputRef.current.value = null;
    }
  };

  useEffect(() => {
    if (isRemovingRef.current) {
      isRemovingRef.current = false;
      return;
    }

    if (file) {
      console.log("File:", file);
      handleUploadCC();
    }

    if (errorCodeCC === "ERROR") {
      setStatusCC("Upload failed validation error");
    } else if (errorCodeCC === "OK") {
      setStatusCC("");
    }
  }, [errorCodeCC, file]);

  const handleFile2Change = (e) => {
    const file = e.target.files[0];
    setFile2(file);
    // reset verification lock for new file
    hasVerifiedRef.current = false;

    setStatusTF(null);
  };

  const removeFile2 = () => {
    isRemovingRef2.current = true;
    setFile2(null);
    setStatusTF(null);
    setLoading(false);
    if (fileInputRef2.current) {
      fileInputRef2.current.value = "";
    }
  };

  useEffect(() => {
    if (!file2) return;
    // prevent duplicate calls caused by re-renders or Strict Mode
    if (hasVerifiedRef.current) return;
    hasVerifiedRef.current = true;

    const processFile = async () => {
      //1. first: verify upload
      const ptype = await handleUploadTFVerify();
      console.log("Verified product_type:", ptype);

      //2. if product_B → STOP here
      if (ptype === "product_B") {
        console.log("Product B detected — stopping after verification.");
        return;
      }
      if (ptype === "product_A") {
        setStatusTF("This is a product A");
      }
      //3. else: upload transaction file
      console.log("Not Product B — uploading TF...");
      await handleUploadTF();
    };

    processFile();
  }, [file2]);

  return (
    <>
      <h4
        style={{ textAlign: "center", marginBottom: "10px", marginTop: "30px" }}
      >
        Upload Client Card & Transaction File
      </h4>
      <hr />
      <div
        style={{
          backgroundColor: "#f3f3f3",
          padding: "20px",
          borderRadius: "10px",
          marginBottom: "10px",
        }}
      >
        <label style={{ fontWeight: "bold" }}>
          Upload Client Card (CC) <span className="text-danger">*</span>
        </label>
        <br />
        <input type="file" onChange={handleFile1Change} ref={fileInputRef} />
      </div>

      {file && (
        <div
          style={{
            border: "1px solid #ccc",
            borderRadius: "8px",
            padding: "10px",
            marginTop: "10px",
            marginBottom: "20px",
            position: "relative",
          }}
        >
          <div>
            <p style={{ margin: "5px 0", fontWeight: "bold" }}>{file.name}</p>
            <p style={{ margin: "5px 0", color: "#555" }}>
              {(file.size / 1024).toFixed(2)} KB
            </p>
          </div>
          <button
            onClick={removeFile}
            style={{
              position: "absolute",
              top: "10px",
              right: "10px",
              backgroundColor: "#f44336",
              color: "#fff",
              border: "none",
              borderRadius: "50%",
              width: "25px",
              height: "25px",
              cursor: "pointer",
            }}
          >
            &times;
          </button>
        </div>
      )}

      {statusCC && (
        <p
          style={{
            color: statusCC.includes("error")
              ? "#f44336"
              : statusCC.includes("successfully")
              ? "green"
              : "grey",
            marginTop: "-20px",
            textAlign: "center",
          }}
        >
          {statusCC}
        </p>
      )}

      <div
        style={{
          backgroundColor: "#f3f3f3",
          padding: "20px",
          borderRadius: "10px",
        }}
      >
        <label style={{ fontWeight: "bold" }}>
          Upload Transaction File (TF) <span className="text-danger">*</span>
        </label>
        <br />
        <input type="file" onChange={handleFile2Change} ref={fileInputRef2} />
      </div>

      {file2 && (
        <div
          style={{
            border: "1px solid #ccc",
            borderRadius: "8px",
            padding: "10px",
            marginTop: "10px",
            position: "relative",
          }}
        >
          <div>
            <p style={{ margin: "5px 0", fontWeight: "bold" }}>{file2.name}</p>
            <p style={{ margin: "5px 0", color: "#555" }}>
              {(file2.size / 1024).toFixed(2)} KB
            </p>
          </div>
          <button
            onClick={removeFile2}
            style={{
              position: "absolute",
              top: "10px",
              right: "10px",
              backgroundColor: "#f44336",
              color: "#fff",
              border: "none",
              borderRadius: "50%",
              width: "24px",
              height: "24px",
              cursor: "pointer",
            }}
          >
            &times;
          </button>
        </div>
      )}

      {statusTF && (
        <p
          style={{
            color:
              statusTF.includes("error") ||
              statusTF.toLowerCase().includes("product a")
                ? "#f44336"
                : statusTF.includes("successfully")
                ? "green"
                : "grey",
            marginTop: "5px",
            textAlign: "center",
          }}
        >
          {statusTF}
        </p>
      )}

      <button
        onClick={handleUpload}
        disabled={loading || alertMsg}
        className="btn btn-primary"
        style={{ marginTop: "30px" }}
      >
        {loading
          ? "Generating isheet"
          : loading === "error"
          ? "something wrong with the files"
          : "Generate iSheet"}
      </button>
      {status && (
        <p
          style={{
            backgroundColor: status.includes("error")
              ? "#7b1103"
              : status.includes("successfully")
              ? "green"
              : "grey",
            borderRadius: "10px",
            marginTop: "10px",
            padding: "10px",
            color: "#fff",
          }}
        >
          {status}
        </p>
      )}
    </>
  );
};

export default FileUploadProductB;
